
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Kop7", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e99f81a33dc1977$export$2e2bcd8739ae039);

var $8qMNj = parcelRequire("8qMNj");


var $3yGK6 = parcelRequire("3yGK6");

function $4e99f81a33dc1977$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $8qMNj.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $8qMNj.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});

parcelRegister("a9CAg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $iDrrr = parcelRequire("iDrrr");


var $fvoKJ = parcelRequire("fvoKJ");


var $4slsU = parcelRequire("4slsU");

const $09474dda4072b632$export$e63df29a0d863446 = /*#__PURE__*/ (0, $cozmU.createContext)({
    containerId: '',
    orgId: '',
    currentUser: undefined,
    analyticsAttributes: {},
    isEditable: undefined,
    isOwnerOrContributor: undefined,
    parentCloudId: undefined,
    parentProduct: undefined
});
const $09474dda4072b632$export$983f1b3296a88282 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    let t0;
    if ($[0] !== context.containerId || $[1] !== context.currentUser || $[2] !== context.mediaProvider || $[3] !== context.orgId || $[4] !== context.parentProduct) {
        t0 = {
            containerId: context.containerId,
            orgId: context.orgId,
            currentUser: context.currentUser,
            parentProduct: context.parentProduct,
            mediaProvider: context.mediaProvider
        };
        $[0] = context.containerId;
        $[1] = context.currentUser;
        $[2] = context.mediaProvider;
        $[3] = context.orgId;
        $[4] = context.parentProduct;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return {
        containerId: context.containerId,
        orgId: context.orgId,
        currentUser: context.currentUser,
        parentProduct: context.parentProduct,
        mediaProvider: context.mediaProvider
    };
};
const $09474dda4072b632$export$2b163c291f77b3f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (bridge, url, app, destinationApp, t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const featureFlag = t0 === undefined ? "projects_goals" : t0;
    let t1;
    if ($[0] !== featureFlag) {
        t1 = featureFlag === "teams" ? (0, $iDrrr.fg)("townsquare_teams_cross_app_mau") : (0, $iDrrr.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = featureFlag;
        $[1] = t1;
    } else t1 = $[1];
    const enableCrossMAUUsage = t1;
    let t2;
    if ($[2] !== app || $[3] !== bridge) {
        t2 = {
            bridge: bridge,
            product: "townsquare",
            subProduct: app
        };
        $[2] = app;
        $[3] = bridge;
        $[4] = t2;
    } else t2 = $[4];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t2);
    let t3;
    if ($[5] !== app || $[6] !== buildUrlWithAnalyticsParams || $[7] !== destinationApp || $[8] !== enableCrossMAUUsage || $[9] !== url) {
        t3 = enableCrossMAUUsage && app !== destinationApp ? buildUrlWithAnalyticsParams(url) : url;
        $[5] = app;
        $[6] = buildUrlWithAnalyticsParams;
        $[7] = destinationApp;
        $[8] = enableCrossMAUUsage;
        $[9] = url;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (bridge, url, app, destinationApp, featureFlag = 'projects_goals')=>{
    const enableCrossMAUUsage = featureFlag === 'teams' ? (0, $iDrrr.fg)('townsquare_teams_cross_app_mau') : (0, $iDrrr.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: app
    });
    return enableCrossMAUUsage && app !== destinationApp ? buildUrlWithAnalyticsParams(url) : url;
};
const $09474dda4072b632$export$d36abdbf11ab2585 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.containerId;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.containerId;
};
const $09474dda4072b632$export$74b3df1a9c1b5a75 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.orgId;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.orgId;
};
const $09474dda4072b632$export$e7e0505785ad2188 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    let t0;
    if ($[0] !== context.containerId) {
        t0 = (0, $fvoKJ.getSiteAri)(context.containerId);
        $[0] = context.containerId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return (0, $fvoKJ.getSiteAri)(context.containerId);
};
const $09474dda4072b632$export$dc46edbccdbce3f2 = (entityType, entityAri)=>(0, $fvoKJ.getSiteAri)((0, $4slsU.getSiteId)(entityType, entityAri));
const $09474dda4072b632$export$1fd8522aeddaccda = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.analyticsAttributes;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.analyticsAttributes;
};
const $09474dda4072b632$export$6f2ead18de56f0f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.isEditable === undefined ? true : context.isEditable;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    // Default to editable as this is the most common case
    return context.isEditable === undefined ? true : context.isEditable;
};
const $09474dda4072b632$export$e07543bf5116993d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return !!context.isOwnerOrContributor;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return !!context.isOwnerOrContributor;
};
const $09474dda4072b632$export$e57bd79b746d66f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.containerId === context.parentCloudId;
} : ()=>{
    const context = (0, $cozmU.useContext)($09474dda4072b632$export$e63df29a0d863446);
    return context.containerId === context.parentCloudId;
};
const $09474dda4072b632$export$57570b1603cf6adb = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const jiraEnv = document.querySelector('meta[name=ajs-environment]')?.content;
    if (jiraEnv === 'staging') return 'staging';
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const townsquareEnv = document.querySelector('meta[name=env]')?.content;
    if (townsquareEnv?.startsWith('stg')) return 'staging';
    return 'prod';
};
module.exports["ProjectsGoalsContext"] = $09474dda4072b632$export$e63df29a0d863446;
module.exports["useProjectsGoals"] = $09474dda4072b632$export$983f1b3296a88282;
module.exports["useGetCrossProductWrappedUrl"] = $09474dda4072b632$export$2b163c291f77b3f9;
module.exports["useProjectsGoalsContainerId"] = $09474dda4072b632$export$d36abdbf11ab2585;
module.exports["useProjectsGoalsOrgId"] = $09474dda4072b632$export$74b3df1a9c1b5a75;
module.exports["useProjectsGoalsSiteAri"] = $09474dda4072b632$export$e7e0505785ad2188;
module.exports["getEntityContainerAri"] = $09474dda4072b632$export$dc46edbccdbce3f2;
module.exports["useAnalyticsAttributes"] = $09474dda4072b632$export$1fd8522aeddaccda;
module.exports["useIsProjectsGoalsEditable"] = $09474dda4072b632$export$6f2ead18de56f0f0;
module.exports["useIsProjectsGoalsOwnerOrContributor"] = $09474dda4072b632$export$e07543bf5116993d;
module.exports["useIsSameSite"] = $09474dda4072b632$export$e57bd79b746d66f1;
module.exports["getEnvironment"] = $09474dda4072b632$export$57570b1603cf6adb;

});

parcelRegister("jPsoD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l7jo6 = parcelRequire("l7jo6");


var $9DHhW = parcelRequire("9DHhW");


var $a9CAg = parcelRequire("a9CAg");

const $b1dcbc926df85763$export$e955abb82869dc84 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const baseAnalyticsAttributes = (0, $a9CAg.useAnalyticsAttributes)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== baseAnalyticsAttributes || $[1] !== createAnalyticsEvent) {
        t0 = (eventType)=>(actionSubject, action, attributes)=>{
                createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject,
                    eventType: eventType,
                    tags: [
                        "townsquare"
                    ],
                    attributes: {
                        ...baseAnalyticsAttributes,
                        ...attributes
                    }
                }).fire("atlas");
            };
        $[0] = baseAnalyticsAttributes;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const fire = t0;
    let t1;
    if ($[3] !== fire) {
        t1 = {
            track: fire("track"),
            ui: fire("ui"),
            operational: fire("operational")
        };
        $[3] = fire;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const baseAnalyticsAttributes = (0, $a9CAg.useAnalyticsAttributes)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useMemo)(()=>{
        const fire = (eventType)=>(actionSubject, action, attributes)=>{
                createAnalyticsEvent({
                    action: action,
                    actionSubject: actionSubject,
                    eventType: eventType,
                    tags: [
                        'townsquare'
                    ],
                    attributes: {
                        ...baseAnalyticsAttributes,
                        ...attributes
                    }
                }).fire('atlas');
            };
        return {
            track: fire('track'),
            ui: fire('ui'),
            operational: fire('operational')
        };
    }, [
        baseAnalyticsAttributes,
        createAnalyticsEvent
    ]);
};
function $b1dcbc926df85763$export$1ea3536c4f602870(analyticsClient, subproduct, accountId, orgId, cloudId) {
    analyticsClient.setSubproduct(subproduct);
    if (orgId && orgId !== '') analyticsClient.setOrgInfo(orgId);
    if (cloudId && cloudId !== '') analyticsClient.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
    else analyticsClient.setTenantInfo((0, $l7jo6.tenantType).NONE, cloudId);
    if (accountId && accountId !== '') analyticsClient.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, accountId);
}
module.exports["useAnalytics"] = $b1dcbc926df85763$export$e955abb82869dc84;
module.exports["setAnalyticsClientInfo"] = $b1dcbc926df85763$export$1ea3536c4f602870;

});

parcelRegister("fGh4B", function(module, exports) {
const $5ed791c20f91b82c$export$10f0a7ad1b455255 = {
    // Users can view directories: https://tome.prod.atl-paas.net/capability/7bfb7463-655a-4475-b93a-790a7cefa6d4
    ProjectDirectoryViewed: 'projectDirectoryViewed',
    GoalDirectoryViewed: 'goalDirectoryViewed',
    TopicDirectoryViewed: 'topicDirectoryViewed',
    TopicPageViewed: 'topicPageViewed',
    ProjectAboutPageViewed: 'projectAboutPageViewed',
    ProjectUpdatesPageViewed: 'projectUpdatesPageViewed',
    ProjectLearningsPageViewed: 'projectLearningsPageViewed',
    ReadingModeViewed: 'readingModeViewed',
    TopicsHelpAndKnowledgePageViewed: 'topicsHelpAndKnowledgePageViewed',
    TopicsUpdatesPageViewed: 'topicsUpdatesPageViewed',
    PersonalSettingsPageViewed: 'personalSettingsPageViewed',
    WorkspaceSettingsPageViewed: 'workspaceSettingsPageViewed',
    FieldSettingsPageViewed: 'fieldSettingsPageViewed',
    TeamsSettingsPageViewed: 'teamsSettingsPageViewed',
    // No workspace
    NoWorkspaceTeamsDirectoryViewed: 'noWorkspaceTeamsDirectoryViewed',
    NoWorkspaceProjectsDirectoryViewed: 'noWorkspaceProjectsDirectoryViewed',
    NoWorkspaceGoalsDirectoryViewed: 'noWorkspaceGoalsDirectoryViewed',
    NoWorkspaceStatusUpdatesPageViewed: 'noWorkspaceStatusUpdatesPageViewed',
    // Share modals
    ProjectShareModalViewed: 'projectShareModalViewed',
    GoalShareModalViewed: 'goalShareModalViewed',
    TagUpdatesFeedViewed: 'tagUpdatesFeedViewed',
    TeamUpdatesFeedViewed: 'teamUpdatesFeedViewed',
    SavedViewUpdatesViewed: 'savedViewUpdatesViewed',
    ProjectUpdatesFeedViewed: 'projectUpdatesFeedViewed',
    GoalUpdatesFeedViewed: 'goalUpdatesFeedViewed',
    // Focus area sidebar
    // Dashboards: https://tome.prod.atl-paas.net/capability/d3b83c3d-5f28-4552-99b0-158d8fe7abc4
    FocusAreaUnlinked: 'townsquare-unlink-focus-area',
    FocusAreaSidebarViewed: 'focusAreaSidebarViewed',
    // Goal page tabs
    // Dashboards: https://tome.prod.atl-paas.net/capability/ecec3a20-a466-432b-bb6f-9ebdcbf87560
    GoalAboutTabViewed: 'goal-about-tab-viewed',
    GoalUpdatesTabViewed: 'goal-updates-tab-viewed',
    GoalJiraTabViewed: 'goal-jira-tab-viewed',
    GoalJiraAlignTabViewed: 'goal-jiraAlign-tab-viewed',
    GoalProjectsTabViewed: 'goal-projects-tab-viewed',
    GoalLearningsTabViewed: 'goal-learnings-tab-viewed',
    GoalRisksTabViewed: 'goal-risks-tab-viewed',
    GoalDecisionsTabViewed: 'goal-decisions-tab-viewed',
    // Project page tabs
    // Dashboards: https://tome.prod.atl-paas.net/capability/ecec3a20-a466-432b-bb6f-9ebdcbf87560
    ProjectAboutTabViewed: 'project-about-tab-viewed',
    ProjectUpdatesTabViewed: 'project-updates-tab-viewed',
    ProjectLearningsTabViewed: 'project-learnings-tab-viewed',
    ProjectRisksTabViewed: 'project-risks-tab-viewed',
    ProjectDecisionsTabViewed: 'project-decisions-tab-viewed',
    // Comments
    // https://tome.prod.atl-paas.net/capability/8edd3fa6-02ff-424f-968f-33a618bf53b6
    GoalCommentsViewed: 'goalCommentsViewed',
    ProjectCommentsViewed: 'projectCommentsViewed',
    GoalUpdateCommentsViewed: 'goalUpdateCommentsViewed',
    ProjectUpdatesCommentsViewed: 'projectUpdateCommentsViewed',
    //Starred feed
    StarredFeedViewed: 'starredFeedViewed',
    // Home / page-level segmented regions
    // Dashboards: https://tome.prod.atl-paas.net/capability/d3b83c3d-5f28-4552-99b0-158d8fe7abc4
    WhereYouWorkViewed: 'whereYouWorkViewed',
    YourAppsSectionViewed: 'yourAppsSectionViewed',
    ThreadsViewed: 'threadsViewed',
    // Metric targets
    CreateMetricTarget: 'townsquare-create-metric-target',
    ShareGoal: 'townsquare-share-goal',
    ShareProject: 'townsquare-share-project',
    // Project updates
    CreateNewProjectUpdate: 'townsquare-create-new-project-update',
    CreateNewProjectUpdateInline: 'townsquare-create-new-project-update-inline',
    // Goal updates
    CreateNewGoalUpdate: 'townsquare-create-new-goal-update',
    // Goal create
    GoalCreate: 'townsquare-goal-create',
    GoalMetricCreate: 'townsquare-goal-metric-create',
    SuccessMeasureCreate: 'townsquare-success-measure-create',
    // Project follow/unfollow
    FollowProject: 'townsquare-follow-project',
    UnfollowProject: 'townsquare-unfollow-project',
    // Goal follow/unfollow
    FollowGoal: 'townsquare-follow-goal',
    UnfollowGoal: 'townsquare-unfollow-goal',
    // Team follow/unfollow
    FollowTeam: 'townsquare-follow-team',
    UnfollowTeam: 'townsquare-unfollow-team',
    FollowTag: 'townsquare-follow-tag',
    // Tags
    AddTag: 'townsquare-add-tag',
    CreateTag: 'townsquare-create-tag',
    RemoveTag: 'townsquare-remove-tag',
    // Comments
    CreateComment: 'create-townsquare-comment',
    EditComment: 'edit-townsquare-comment',
    DeleteComment: 'delete-townsquare-comment',
    // Custom fields
    EditCustomFieldText: 'townsquare-edit-custom-field-text',
    EditCustomFieldNumber: 'townsquare-edit-custom-field-number',
    AddCustomFieldSelect: 'townsquare-add-custom-field-select',
    DeleteCustomFieldSelect: 'townsquare-delete-custom-field-select',
    AddCustomFieldUser: 'townsquare-add-custom-field-user',
    DeleteCustomFieldUser: 'townsquare-delete-custom-field-user'
};
const $5ed791c20f91b82c$export$1d35ca915d282aa4 = {
    // Custom fields
    EditCustomFieldTextLoading: 'townsquare-edit-custom-field-text-loading',
    EditCustomFieldNumberLoading: 'townsquare-edit-custom-field-number-loading',
    AddCustomFieldSelectLoading: 'townsquare-add-custom-field-select-loading',
    DeleteCustomFieldSelectLoading: 'townsquare-delete-custom-field-select-loading',
    AddCustomFieldUserLoading: 'townsquare-add-custom-field-user-loading',
    DeleteCustomFieldUserLoading: 'townsquare-delete-custom-field-user-loading',
    CreateCommentLoading: 'townsquare-create-comment-loading',
    CreateMetricTargetLoading: 'townsquare-create-metric-target-loading',
    CreateNewProjectUpdateLoading: 'townsquare-create-new-project-update-loading',
    CreateNewProjectUpdateInlineLoading: 'townsquare-create-new-project-update-inline-loading',
    CreateNewGoalUpdateLoading: 'townsquare-create-new-goal-update-loading',
    FollowProjectLoading: 'townsquare-project-follow-button-loading',
    FollowGoalLoading: 'townsquare-goal-follow-button-loading',
    FollowTeamLoading: 'townsquare-team-follow-loading',
    FollowTagLoading: 'townsquare-tag-follow-loading',
    AddTagLoading: 'townsquare-add-tag-loading',
    CreateTagLoading: 'townsquare-create-tag-loading',
    RemoveTagLoading: 'townsquare-remove-tag-loading',
    ProjectActionsFollowLoading: 'townsquare-project-actions-follow-loading',
    ShareGoalLoading: 'townsquare-share-goal-loading',
    ShareProjectLoading: 'townsquare-share-project-loading'
};
const $5ed791c20f91b82c$export$46c1f4b89e3608ae = {
    about: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalAboutTabViewed,
    updates: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalUpdatesTabViewed,
    jira: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalJiraTabViewed,
    jiraAlign: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalJiraAlignTabViewed,
    projects: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalProjectsTabViewed,
    learnings: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalLearningsTabViewed,
    risks: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalRisksTabViewed,
    decisions: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalDecisionsTabViewed
};
const $5ed791c20f91b82c$export$b221a4ba3fa6acf9 = (tabName)=>tabName in $5ed791c20f91b82c$export$46c1f4b89e3608ae;
const $5ed791c20f91b82c$export$d9b64535f2b3a1f = {
    about: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectAboutTabViewed,
    updates: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectUpdatesTabViewed,
    learnings: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectLearningsTabViewed,
    risks: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectRisksTabViewed,
    decisions: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectDecisionsTabViewed
};
const $5ed791c20f91b82c$export$2118843bee3c7be1 = (tabName)=>tabName in $5ed791c20f91b82c$export$d9b64535f2b3a1f;
const $5ed791c20f91b82c$export$7b863cbaf595573 = {
    goal: $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalCommentsViewed,
    'goal-update': $5ed791c20f91b82c$export$10f0a7ad1b455255.GoalUpdateCommentsViewed,
    project: $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectCommentsViewed,
    'project-update': $5ed791c20f91b82c$export$10f0a7ad1b455255.ProjectUpdatesCommentsViewed
};
module.exports["TownsquareInteractionName"] = $5ed791c20f91b82c$export$10f0a7ad1b455255;
module.exports["TownsquareLoadHoldName"] = $5ed791c20f91b82c$export$1d35ca915d282aa4;
module.exports["CommentsSegmentName"] = $5ed791c20f91b82c$export$7b863cbaf595573;

});

parcelRegister("k0hOH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $clx8d = parcelRequire("clx8d");

const $8ed613f576b59b82$var$defaultDateLocale = (0, $clx8d.default);
const $8ed613f576b59b82$var$DateLocaleContext = /*#__PURE__*/ (0, $cozmU.createContext)($8ed613f576b59b82$var$defaultDateLocale);
const $8ed613f576b59b82$export$3e03cf425454bd4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== locale) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ed613f576b59b82$var$DateLocaleContext.Provider, {
            value: locale
        }, children);
        $[0] = children;
        $[1] = locale;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ locale: locale, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ed613f576b59b82$var$DateLocaleContext.Provider, {
        value: locale
    }, children);
const $8ed613f576b59b82$export$99b2dd0981b0b6d2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($8ed613f576b59b82$var$DateLocaleContext);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($8ed613f576b59b82$var$DateLocaleContext);
module.exports["useDateLocale"] = $8ed613f576b59b82$export$99b2dd0981b0b6d2;

});

parcelRegister("iOC0H", function(module, exports) {

var $8qyRg = parcelRequire("8qyRg");


var $gkHoc = parcelRequire("gkHoc");


var $58FyF = parcelRequire("58FyF");


var $3jKk3 = parcelRequire("3jKk3");


var $1Ujre = parcelRequire("1Ujre");


var $fNtG8 = parcelRequire("fNtG8");


var $WeoLw = parcelRequire("WeoLw");


var $gQEZd = parcelRequire("gQEZd");


var $6Mfv2 = parcelRequire("6Mfv2");


var $mr7nI = parcelRequire("mr7nI");


var $bVyw6 = parcelRequire("bVyw6");


var $ftXgz = parcelRequire("ftXgz");


var $7IjeE = parcelRequire("7IjeE");


var $1xxT0 = parcelRequire("1xxT0");


var $d5Gk5 = parcelRequire("d5Gk5");


var $P1m33 = parcelRequire("P1m33");


var $bXFlG = parcelRequire("bXFlG");


var $hAHiR = parcelRequire("hAHiR");


var $hqDv3 = parcelRequire("hqDv3");


var $k5sGX = parcelRequire("k5sGX");

const $6549fe23c1d03852$export$f1dfefafe68679f = ()=>(0, $P1m33.default)($6549fe23c1d03852$export$b3be5876ddaf77c4(), 1);
const $6549fe23c1d03852$export$21bad1dbf7fdd0f1 = (date)=>(0, $bXFlG.isSameWeek)(date, $6549fe23c1d03852$export$b3be5876ddaf77c4());
const $6549fe23c1d03852$export$815a780eb1151f78 = (date)=>(0, $bXFlG.isSameWeek)(date, $6549fe23c1d03852$export$53deaf8cee4d3edf());
const $6549fe23c1d03852$export$8be2b5b9a7e1742 = (date)=>(0, $bXFlG.isSameWeek)(date, (0, $3jKk3.default)($6549fe23c1d03852$export$b3be5876ddaf77c4(), -1));
const $6549fe23c1d03852$export$c1ffdc8d1b5a290b = (date)=>(0, $bXFlG.isSameWeek)(date, (0, $3jKk3.default)($6549fe23c1d03852$export$53deaf8cee4d3edf(), -1));
const $6549fe23c1d03852$export$f22a8550507539dc = (date)=>(0, $ftXgz.default)(date, (0, $58FyF.default)($6549fe23c1d03852$export$b3be5876ddaf77c4(), -1));
const $6549fe23c1d03852$export$c683c625e600737d = (date, amount)=>(0, $gkHoc.default)(date, amount);
const $6549fe23c1d03852$export$f7395c2abb5c1a2d = (date, amount)=>(0, $58FyF.default)(date, amount);
const $6549fe23c1d03852$export$601d6cf336d1ee54 = (date, amount)=>(0, $1xxT0.default)(date, amount);
const $6549fe23c1d03852$export$d91d3014a3a25a08 = (date, amount)=>(0, $d5Gk5.default)(date, amount);
const $6549fe23c1d03852$export$a1dd290013a5c209 = (date, startDate)=>(0, $mr7nI.default)(date, startDate);
const $6549fe23c1d03852$export$7467d14fa50f8750 = (date, endDate)=>(0, $6Mfv2.default)(date, endDate);
const $6549fe23c1d03852$export$a5a3b454ada2268e = (date)=>(0, $7IjeE.default)(date);
const $6549fe23c1d03852$export$a2258d9c4118825c = (date)=>(0, $WeoLw.default)(date);
const $6549fe23c1d03852$export$f08d921968aef68c = (date)=>(0, $gQEZd.default)(date, {
        representation: 'date'
    });
const $6549fe23c1d03852$export$b3be5876ddaf77c4 = (dateString)=>$6549fe23c1d03852$export$539661515529bef(dateString);
const $6549fe23c1d03852$export$539661515529bef = (dateString)=>{
    return dateString ? (0, $hAHiR.utcToWorkspaceTimezone)(dateString) : (0, $8qyRg.utcToZonedTime)(Date.now(), (0, $hqDv3.timezoneHolder).getWorkspaceTimezone());
};
const $6549fe23c1d03852$export$e92a0e48d5941258 = (isoDate)=>(0, $8qyRg.zonedTimeToUtc)(`${isoDate}T00:00:00`, (0, $hqDv3.timezoneHolder).getWorkspaceTimezone()).toISOString();
const $6549fe23c1d03852$export$602cdcdd9da8fc39 = (isoDate)=>(0, $8qyRg.zonedTimeToUtc)(`${isoDate}T00:00:00`, (0, $hqDv3.timezoneHolder).getUserTimezone()).toISOString();
/**
 * Used for offsetting UTC dates to the workspace timezone.
 * For example. Lets say we wanted start of day in America/Los Angeles [-08:00]
 * We can pass in 00:00PM UTC here - and this function will offset to 08:00PM UTC
 */ const $6549fe23c1d03852$var$offsetUtcDateToWorkspaceDate = (date)=>{
    const timezoneOffset = (0, $8qyRg.getTimezoneOffset)((0, $hqDv3.timezoneHolder).getWorkspaceTimezone());
    return new Date(date.valueOf() - timezoneOffset);
};
/**
 * Used for offsetting workspace timezoned dates back to UTC.
 */ const $6549fe23c1d03852$var$offsetWorkspaceDateToUtcDate = (date)=>{
    const timezoneOffset = (0, $8qyRg.getTimezoneOffset)((0, $hqDv3.timezoneHolder).getWorkspaceTimezone());
    return new Date(date.valueOf() + timezoneOffset);
};
const $6549fe23c1d03852$export$53deaf8cee4d3edf = (dateString)=>dateString ? (0, $hAHiR.utcToUserTimezone)(dateString) : (0, $8qyRg.utcToZonedTime)(Date.now(), (0, $hqDv3.timezoneHolder).getUserTimezone());
/**
 * Used for offsetting dates created with date-fns (start of day etc) that actually need to be UTC time.
 * For example. a startOfDay in australia would generate 00:00PM AEST, but that's 1:00PM UTC the previous day
 * This function will offset by the timezone difference, +11:00 in this case. Bringing us back to 00:00PM UTC.
 */ const $6549fe23c1d03852$var$offsetUserDateToUtcDate = (date)=>{
    const timezoneOffset = (0, $8qyRg.getTimezoneOffset)((0, $hqDv3.timezoneHolder).getUserTimezone());
    return new Date(date.valueOf() + timezoneOffset);
};
const $6549fe23c1d03852$export$7719787d462d89c6 = (date)=>{
    const timezoneOffset = (0, $8qyRg.getTimezoneOffset)((0, $hqDv3.timezoneHolder).getUserTimezone());
    return new Date(date.valueOf() - timezoneOffset);
};
const $6549fe23c1d03852$export$56b8b35841afd41e = (date)=>$6549fe23c1d03852$var$offsetUtcDateToWorkspaceDate($6549fe23c1d03852$var$offsetUserDateToUtcDate(date));
const $6549fe23c1d03852$export$c9e317ac9a609d9c = (date)=>$6549fe23c1d03852$export$7719787d462d89c6($6549fe23c1d03852$var$offsetWorkspaceDateToUtcDate(date));
const $6549fe23c1d03852$export$200ab5b8c99897d7 = (dateString)=>dateString ? (0, $bVyw6.default)(new Date(`${dateString.split('T')[0]}T23:59:59`)) : false;
const $6549fe23c1d03852$export$d7fd361eccb0059b = (newDate, oldDate)=>(0, $1Ujre.default)(new Date(newDate), new Date(oldDate));
const $6549fe23c1d03852$export$f76f483821e339a0 = (newTime, oldTime)=>(0, $fNtG8.default)(Number(newTime), Number(oldTime)) > 5;
const $6549fe23c1d03852$export$21e811c5abc6eecb = (start)=>{
    if (!start) return null;
    const parsed = (0, $k5sGX.default)(start);
    return Number.isNaN(parsed.getTime()) ? null : $6549fe23c1d03852$export$a5a3b454ada2268e(parsed);
};
module.exports["tzDate"] = $6549fe23c1d03852$export$b3be5876ddaf77c4;
module.exports["isThisWeekInWorkspaceTZ"] = $6549fe23c1d03852$export$21bad1dbf7fdd0f1;
module.exports["tzUserTimezoneDate"] = $6549fe23c1d03852$export$53deaf8cee4d3edf;
module.exports["plusMonths"] = $6549fe23c1d03852$export$f7395c2abb5c1a2d;
module.exports["minusDays"] = $6549fe23c1d03852$export$601d6cf336d1ee54;
module.exports["minusMonths"] = $6549fe23c1d03852$export$d91d3014a3a25a08;
module.exports["isAfterEnd"] = $6549fe23c1d03852$export$7467d14fa50f8750;
module.exports["startOfMonth"] = $6549fe23c1d03852$export$a5a3b454ada2268e;
module.exports["endOfMonth"] = $6549fe23c1d03852$export$a2258d9c4118825c;
module.exports["toISODate"] = $6549fe23c1d03852$export$f08d921968aef68c;
module.exports["tzWorkspaceTimezoneDate"] = $6549fe23c1d03852$export$539661515529bef;
module.exports["workspaceDateToUtcIsoString"] = $6549fe23c1d03852$export$e92a0e48d5941258;
module.exports["userDateToUtcIsoString"] = $6549fe23c1d03852$export$602cdcdd9da8fc39;
module.exports["offsetUserDateToWorkspaceDate"] = $6549fe23c1d03852$export$56b8b35841afd41e;
module.exports["isDateInThePast"] = $6549fe23c1d03852$export$200ab5b8c99897d7;
module.exports["ISODateToStartOfMonth"] = $6549fe23c1d03852$export$21e811c5abc6eecb;

});

parcelRegister("bVyw6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8aefcae63e22e39c$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $8aefcae63e22e39c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $dkBOe.default)(dirtyDate).getTime() < Date.now();
}

});

parcelRegister("hAHiR", function(module, exports) {

var $8qyRg = parcelRequire("8qyRg");


var $fIopu = parcelRequire("fIopu");


var $amKSx = parcelRequire("amKSx");


var $hqDv3 = parcelRequire("hqDv3");

const $bc41d312cfcbd3a4$export$9395a61a87d21679 = (dateTime, timezone)=>{
    const date = typeof dateTime === 'object' ? Date.parse(String(dateTime)) : Date.parse(dateTime && String(dateTime + '').endsWith('Z') ? dateTime : dateTime + 'Z');
    if (isNaN(date)) return (0, $amKSx.parseIsoLocalDateTime)(dateTime, new Date(NaN));
    return (0, $8qyRg.utcToZonedTime)(date, timezone);
};
const $bc41d312cfcbd3a4$export$5f6fbd4959e944da = (dt)=>$bc41d312cfcbd3a4$export$9395a61a87d21679(dt, (0, $hqDv3.timezoneHolder).getUserTimezone());
const $bc41d312cfcbd3a4$export$389c2a1270efa748 = (dt)=>$bc41d312cfcbd3a4$export$9395a61a87d21679(dt, (0, $hqDv3.timezoneHolder).getWorkspaceTimezone());
const $bc41d312cfcbd3a4$export$caa193559b3a89ec = (dateString, locale)=>dateString ? (0, $fIopu.default)($bc41d312cfcbd3a4$export$5f6fbd4959e944da(dateString), (0, $8qyRg.utcToZonedTime)(Date.now(), (0, $hqDv3.timezoneHolder).getUserTimezone(), {
        locale: locale
    }), {
        addSuffix: true,
        locale: locale
    }) : '-';
const $bc41d312cfcbd3a4$export$7ce4a53d328e1580 = (dateString, locale)=>{
    if (!dateString) return '-';
    const startDate = new Date(dateString);
    startDate.setHours(0, 0, 0, 0);
    const userTimezone = (0, $hqDv3.timezoneHolder).getUserTimezone();
    const baseDate = (0, $8qyRg.utcToZonedTime)(Date.now(), userTimezone, {
        locale: locale
    });
    return (0, $fIopu.default)(startDate, baseDate, {
        addSuffix: true,
        locale: locale
    });
};
module.exports["utcToUserTimezone"] = $bc41d312cfcbd3a4$export$5f6fbd4959e944da;
module.exports["utcToWorkspaceTimezone"] = $bc41d312cfcbd3a4$export$389c2a1270efa748;
module.exports["formatUserRelativeDistance"] = $bc41d312cfcbd3a4$export$caa193559b3a89ec;

});

parcelRegister("amKSx", function(module, exports) {

var $hSoEi = parcelRequire("hSoEi");


var $k5sGX = parcelRequire("k5sGX");


var $h07Gd = parcelRequire("h07Gd");


var $bXFlG = parcelRequire("bXFlG");

const $d0e9c6b5917dea23$export$e624d7c6c4ee7adb = (dateString, defaultValue, timezoneOffset)=>{
    if (dateString) {
        let date = (0, $bXFlG.parse)(dateString, (0, $h07Gd.ISO_LOCAL_DATE_TIME), defaultValue);
        // Used to shift dates back to UTC time (parse will automatically add the user's timezone to dates)
        if (date && timezoneOffset) date = new Date(date.valueOf() + timezoneOffset);
        if (!date || isNaN(date.getTime())) date = (0, $k5sGX.default)(dateString);
        if (!date || isNaN(date.getTime())) date = defaultValue;
        return date;
    } else return defaultValue;
};
function $d0e9c6b5917dea23$export$6c38b421fc127069(value) {
    const datePart = value.slice(0, 10);
    return (0, $hSoEi.default)(datePart, (0, $h07Gd.ISO_LOCAL_DATE), new Date());
}
module.exports["parseIsoLocalDateTime"] = $d0e9c6b5917dea23$export$e624d7c6c4ee7adb;
module.exports["parseValueToLocalDate"] = $d0e9c6b5917dea23$export$6c38b421fc127069;

});

parcelRegister("hqDv3", function(module, exports) {
const $b0bcb41318367997$export$14ec4245743e2694 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
/**
 * A way to hold timezone information so it's accessible outside of a react component
 */ class $b0bcb41318367997$var$TimezoneHolder {
    getWorkspaceTimezone() {
        // Resolve to user timezone if global/workspace timezone is undefined
        return this.workspaceTimezone || $b0bcb41318367997$export$14ec4245743e2694();
    }
    getUserTimezone() {
        return this.userAccountTimezone || $b0bcb41318367997$export$14ec4245743e2694();
    }
    setWorkspaceTimezone(workspaceTimezone) {
        // this.timezone = 'America/New_York';
        // this.timezone = 'Australia/Sydney';
        this.workspaceTimezone = workspaceTimezone;
    }
    setUserTimezone(userAccountTimezone) {
        this.userAccountTimezone = userAccountTimezone;
    }
    constructor(workspaceTimezone, userAccountTimezone){
        this.workspaceTimezone = void 0;
        this.userAccountTimezone = void 0;
        this.workspaceTimezone = workspaceTimezone;
        this.userAccountTimezone = userAccountTimezone;
    }
}
const $b0bcb41318367997$export$438f03caaf265d92 = new $b0bcb41318367997$var$TimezoneHolder();
module.exports["timezoneHolder"] = $b0bcb41318367997$export$438f03caaf265d92;

});

parcelRegister("26dZt", function(module, exports) {

var $8qyRg = parcelRequire("8qyRg");


var $2mU4K = parcelRequire("2mU4K");


var $ftXgz = parcelRequire("ftXgz");


var $hqoIw = parcelRequire("hqoIw");


var $79e2I = parcelRequire("79e2I");


var $bUydO = parcelRequire("bUydO");


var $kSwu1 = parcelRequire("kSwu1");


var $h07Gd = parcelRequire("h07Gd");


var $bXFlG = parcelRequire("bXFlG");


var $iOC0H = parcelRequire("iOC0H");

const $6197a755fe50d207$export$2e9241a0bdf6c8b8 = (from, to, locale, separator = '-')=>{
    if ((0, $hqoIw.default)(from, to)) {
        const fromDisplay = (0, $bXFlG.format)(from, (0, $ftXgz.default)(from, to) ? (0, $h07Gd.SAME_MONTH_FORMAT) : (0, $h07Gd.SAME_YEAR_FORMAT), {
            locale: locale
        });
        const toDisplay = $6197a755fe50d207$export$9b0e8a03930c4b1e(to, locale);
        return `${fromDisplay}${separator}${toDisplay}`;
    } else {
        const fromDisplay = (0, $bXFlG.format)(from, (0, $h07Gd.DIFF_YEAR_FORMAT), {
            locale: locale
        });
        const toDisplay = (0, $bXFlG.format)(to, (0, $h07Gd.DIFF_YEAR_FORMAT), {
            locale: locale
        });
        return `${fromDisplay}${separator}${toDisplay}`;
    }
};
const $6197a755fe50d207$export$6af622c1a7099d35 = (date, _locale, noDash)=>{
    return (0, $bXFlG.format)(date, noDash ? (0, $h07Gd.DIFF_YEAR_FORMAT) : (0, $h07Gd.FULL_NICE_FORMAT));
};
const $6197a755fe50d207$export$cec1db3fd4087308 = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $79e2I.default)(date) ? (0, $h07Gd.MONTH_ONLY_FORMAT) : (0, $h07Gd.MONTH_ONLY_FORMAT_DIFF_YEAR), locale);
const $6197a755fe50d207$export$e803f8efbcba5b94 = (intl, date, { useFullMonth: useFullMonth = false, referenceDate: referenceDate = (0, $iOC0H.tzDate)() } = {})=>intl.formatDate(date, {
        month: useFullMonth ? 'long' : 'short',
        ...(0, $hqoIw.default)(date, referenceDate) ? {} : {
            year: 'numeric'
        }
    });
const $6197a755fe50d207$export$446ec9bc291d6ba4 = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $h07Gd.MONTH_WITH_YEAR), locale);
const $6197a755fe50d207$export$f18cba231431b904 = (fiscalYearPrefix, intervalName, date, locale)=>{
    const year = $6197a755fe50d207$export$fb3485f471c77284(date, 'yy', locale);
    return `${intervalName} ${fiscalYearPrefix}${year}`;
};
const $6197a755fe50d207$export$a759ab4dd7c186ad = (fiscalYearPrefix, intervalDisplayName, startDate, endDate, locale)=>{
    const startYear = $6197a755fe50d207$export$fb3485f471c77284(startDate, 'yy', locale);
    const endYear = $6197a755fe50d207$export$fb3485f471c77284(endDate, 'yy', locale);
    const rangeParts = intervalDisplayName.split(" \u2013 ");
    if (rangeParts.length === 2) {
        if (startYear === endYear) return `${intervalDisplayName} ${fiscalYearPrefix}${startYear}`;
        return `${rangeParts[0]} ${fiscalYearPrefix}${startYear} \u{2013} ${rangeParts[1]} ${fiscalYearPrefix}${endYear}`;
    }
    return $6197a755fe50d207$export$f18cba231431b904(fiscalYearPrefix, intervalDisplayName, startDate, locale);
};
const $6197a755fe50d207$export$65cbe7f37a8de928 = (date, locale)=>`${$6197a755fe50d207$export$fb3485f471c77284((0, $bUydO.default)(date), (0, $h07Gd.MONTH_ONLY_FORMAT_SHORT), locale)}-${$6197a755fe50d207$export$fb3485f471c77284((0, $2mU4K.default)(date), (0, $79e2I.default)(date) ? (0, $h07Gd.MONTH_ONLY_FORMAT_SHORT) : (0, $h07Gd.MONTH_ONLY_FORMAT_DIFF_YEAR), locale)}`;
const $6197a755fe50d207$export$aeec403faa363c87 = (date, locale)=>`${$6197a755fe50d207$export$fb3485f471c77284((0, $bUydO.default)(date), (0, $h07Gd.MONTH_ONLY_FORMAT), locale)}-${$6197a755fe50d207$export$fb3485f471c77284((0, $2mU4K.default)(date), (0, $h07Gd.MONTH_WITH_YEAR), locale)}`;
const $6197a755fe50d207$export$7737235a051de40b = (dateString, locale)=>{
    return $6197a755fe50d207$export$9b0e8a03930c4b1e((0, $iOC0H.tzDate)(dateString), locale);
};
const $6197a755fe50d207$export$9b0e8a03930c4b1e = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $79e2I.default)(date) ? (0, $h07Gd.SAME_YEAR_FORMAT) : (0, $h07Gd.DIFF_YEAR_FORMAT), locale);
const $6197a755fe50d207$export$47fbc3e2a5240e18 = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $h07Gd.FULL_DATE_FORMAT), locale);
const $6197a755fe50d207$export$fb3485f471c77284 = (date, dateFormat, locale)=>(0, $bXFlG.format)(date, dateFormat, {
        locale: locale
    });
const $6197a755fe50d207$export$dcb72c0d0fb82631 = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $h07Gd.NICE_DATE_TIME), locale);
const $6197a755fe50d207$export$4fb1e26192f7e97e = (date, locale)=>(0, $bXFlG.format)(date, (0, $h07Gd.ISO_LOCAL_DATE_WITH_SLASHES), {
        locale: locale
    });
const $6197a755fe50d207$export$aa4631c15cf4aa6c = (date, locale)=>$6197a755fe50d207$export$fb3485f471c77284(date, (0, $h07Gd.MONTH_ONLY_FORMAT), locale);
const $6197a755fe50d207$export$576edf138d340b5d = (date, locale)=>(0, $bXFlG.format)(date, (0, $h07Gd.ISO_LOCAL_DATE), {
        locale: locale
    });
const $6197a755fe50d207$export$558b4e1f078554d3 = (date, locale)=>(0, $bXFlG.format)((0, $8qyRg.utcToZonedTime)(date, 'UTC', {
        locale: locale
    }), (0, $h07Gd.ISO_LOCAL_DATE_TIME), {
        locale: locale
    });
const $6197a755fe50d207$export$1563a4bbc9fdec3a = (intl, start, end, anchorDate = (0, $iOC0H.tzDate)(), locale)=>{
    if ((0, $bXFlG.isSameWeek)(anchorDate, start, {
        locale: locale
    })) return intl.formatMessage({
        id: "townsquare.date-utils.week-range.this-week",
        defaultMessage: "This week"
    });
    else if ($6197a755fe50d207$export$e83bab6391267bac(anchorDate, end, locale)) return intl.formatMessage({
        id: "townsquare.date-utils.week-range.last-week",
        defaultMessage: "Last week"
    });
    else return $6197a755fe50d207$export$2e9241a0bdf6c8b8(start, end, locale);
};
const $6197a755fe50d207$export$9882f45862b3ea7b = (start, end, anchorDate = (0, $iOC0H.tzDate)(), locale)=>{
    const intl = (0, $kSwu1.useIntl)();
    return $6197a755fe50d207$export$1563a4bbc9fdec3a(intl, start, end, anchorDate, locale);
};
function $6197a755fe50d207$export$e83bab6391267bac(newer, older, locale) {
    return (0, $bXFlG.differenceInCalendarWeeks)(newer, older, {
        locale: locale
    }) === 1;
}
module.exports["formatNiceDate"] = $6197a755fe50d207$export$9b0e8a03930c4b1e;
module.exports["formatFullNiceDate"] = $6197a755fe50d207$export$6af622c1a7099d35;
module.exports["formatNiceMonthDate"] = $6197a755fe50d207$export$cec1db3fd4087308;
module.exports["formatWithLocale"] = $6197a755fe50d207$export$fb3485f471c77284;
module.exports["formatUpdatePeriodMonth"] = $6197a755fe50d207$export$e803f8efbcba5b94;
module.exports["formatTooltipNiceMonthDate"] = $6197a755fe50d207$export$446ec9bc291d6ba4;
module.exports["formatNiceIntervalRangeDate"] = $6197a755fe50d207$export$a759ab4dd7c186ad;
module.exports["formatNiceQuarterDate"] = $6197a755fe50d207$export$65cbe7f37a8de928;
module.exports["formatTooltipNiceQuarterDate"] = $6197a755fe50d207$export$aeec403faa363c87;
module.exports["formatNiceDateTooltip"] = $6197a755fe50d207$export$47fbc3e2a5240e18;
module.exports["formatNiceDateTime"] = $6197a755fe50d207$export$dcb72c0d0fb82631;
module.exports["formatMonthOnlyDate"] = $6197a755fe50d207$export$aa4631c15cf4aa6c;
module.exports["formatIsoLocalDate"] = $6197a755fe50d207$export$576edf138d340b5d;
module.exports["formatWeekRange"] = $6197a755fe50d207$export$1563a4bbc9fdec3a;

});

parcelRegister("2mU4K", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b992249e4b341b4$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1b992249e4b341b4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("79e2I", function(module, exports) {
$parcel$export(module.exports, "default", () => $534444400dcab14b$export$2e2bcd8739ae039);

var $hqoIw = parcelRequire("hqoIw");


var $3yGK6 = parcelRequire("3yGK6");

function $534444400dcab14b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $hqoIw.default)(dirtyDate, Date.now());
}

});

parcelRegister("bUydO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8abf78660eaf6d37$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $8abf78660eaf6d37$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("eOWDG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $iDrrr = parcelRequire("iDrrr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $1soKT = parcelRequire("1soKT");

var $k0hOH = parcelRequire("k0hOH");

var $8d907002e8695178$export$d19e7d63e5f456d1 = /*#__PURE__*/ function(ChangeSource) {
    ChangeSource["DATE_SELECT"] = "DATE_SELECT";
    ChangeSource["SCALE_SELECT"] = "SCALE_SELECT";
    return ChangeSource;
}({});



var $7nrck = parcelRequire("7nrck");











var $WeoLw = parcelRequire("WeoLw");


var $2mU4K = parcelRequire("2mU4K");


var $k5sGX = parcelRequire("k5sGX");


var $7IjeE = parcelRequire("7IjeE");


var $bUydO = parcelRequire("bUydO");








var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $26dZt = parcelRequire("26dZt");

















var $esV19 = parcelRequire("esV19");


var $dFOvD = parcelRequire("dFOvD");





var $3u5lg = parcelRequire("3u5lg");


var $buG8Z = parcelRequire("buG8Z");







const $4f412f3052943294$var$getDateObj = (date)=>({
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    });
const $4f412f3052943294$var$getValidDate = (iso)=>{
    if (!iso) return {};
    const date = (0, $k5sGX.default)(iso);
    return (0, $esV19.default)(date) ? $4f412f3052943294$var$getDateObj(date) : {};
};
const $4f412f3052943294$export$a7de57e5b672ccdb = (num)=>num <= 99 ? `0${num}`.slice(-2) : `${num}`;
const $4f412f3052943294$export$97e6db89a86ff7ab = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(30);
    const currentDate = props.date;
    const previousDate = props.previousDate;
    const { minDate: minDate, maxDate: maxDate } = props;
    const [viewDate, setViewDate] = (0, $cozmU.useState)(currentDate);
    const locale = (0, $k0hOH.useDateLocale)();
    let selectedDate;
    let t0;
    if ($[0] !== currentDate || $[1] !== locale || $[2] !== previousDate) {
        const parsedCurrentDate = currentDate ? (0, $k5sGX.default)(currentDate) : undefined;
        const parsedPreviousDate = previousDate ? (0, $k5sGX.default)(previousDate) : undefined;
        selectedDate = parsedCurrentDate && (0, $esV19.default)(parsedCurrentDate) ? (0, $26dZt.formatIsoLocalDate)(parsedCurrentDate, locale) : undefined;
        t0 = parsedPreviousDate && (0, $esV19.default)(parsedPreviousDate) ? (0, $26dZt.formatIsoLocalDate)(parsedPreviousDate, locale) : undefined;
        $[0] = currentDate;
        $[1] = locale;
        $[2] = previousDate;
        $[3] = selectedDate;
        $[4] = t0;
    } else {
        selectedDate = $[3];
        t0 = $[4];
    }
    const previousSelectedDate = t0;
    let t1;
    if ($[5] !== props) {
        t1 = (iso)=>{
            setViewDate(iso);
            const newDateObj = {
                start: iso,
                end: iso
            };
            props.onSelect(newDateObj);
        };
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    const onSelect = t1;
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (iso_0)=>{
            if (!iso_0) return;
            const [year, month, date] = iso_0.split("-");
            let newIso;
            const parsedDate = parseInt(date, 10);
            const parsedMonth = parseInt(month, 10);
            const parsedYear = parseInt(year, 10);
            const lastDayInMonth = (0, $dFOvD.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
            if (lastDayInMonth < parsedDate) newIso = `${year}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedMonth)}-${$4f412f3052943294$export$a7de57e5b672ccdb(lastDayInMonth)}`;
            else newIso = `${year}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedMonth)}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedDate)}`;
            setViewDate(newIso);
        };
        $[7] = t2;
    } else t2 = $[7];
    const onChange = t2;
    let t3;
    if ($[8] !== viewDate) {
        t3 = $4f412f3052943294$var$getValidDate(viewDate);
        $[8] = viewDate;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== locale || $[11] !== minDate) {
        t4 = minDate ? (0, $26dZt.formatIsoLocalDate)(minDate, locale) : undefined;
        $[10] = locale;
        $[11] = minDate;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== locale || $[14] !== maxDate) {
        t5 = maxDate ? (0, $26dZt.formatIsoLocalDate)(maxDate, locale) : undefined;
        $[13] = locale;
        $[14] = maxDate;
        $[15] = t5;
    } else t5 = $[15];
    const t6 = selectedDate || "";
    let t7;
    if ($[16] !== t6) {
        t7 = [
            t6
        ];
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== previousSelectedDate) {
        t8 = previousSelectedDate ? [
            previousSelectedDate
        ] : [];
        $[18] = previousSelectedDate;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (e)=>onChange(e.iso);
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== onSelect) {
        t10 = (e_0)=>onSelect(e_0.iso);
        $[21] = onSelect;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $buG8Z.default), {
            ...t3,
            minDate: t4,
            maxDate: t5,
            selected: t7,
            previouslySelected: t8,
            onChange: t9,
            onSelect: t10
        });
        $[23] = t10;
        $[24] = t3;
        $[25] = t4;
        $[26] = t5;
        $[27] = t7;
        $[28] = t8;
        $[29] = t11;
    } else t11 = $[29];
    return t11;
} : (props)=>{
    const currentDate = props.date;
    const previousDate = props.previousDate;
    const { minDate: minDate, maxDate: maxDate } = props;
    const [viewDate, setViewDate] = (0, $cozmU.useState)(currentDate);
    const locale = (0, $k0hOH.useDateLocale)();
    const parsedCurrentDate = currentDate ? (0, $k5sGX.default)(currentDate) : undefined;
    const parsedPreviousDate = previousDate ? (0, $k5sGX.default)(previousDate) : undefined;
    const selectedDate = parsedCurrentDate && (0, $esV19.default)(parsedCurrentDate) ? (0, $26dZt.formatIsoLocalDate)(parsedCurrentDate, locale) : undefined;
    const previousSelectedDate = parsedPreviousDate && (0, $esV19.default)(parsedPreviousDate) ? (0, $26dZt.formatIsoLocalDate)(parsedPreviousDate, locale) : undefined;
    const onSelect = (0, $cozmU.useCallback)((iso)=>{
        setViewDate(iso);
        const newDateObj = {
            start: iso,
            end: iso
        };
        props.onSelect(newDateObj);
    }, [
        props
    ]);
    const onChange = (0, $cozmU.useCallback)((iso_0)=>{
        if (!iso_0) return;
        const [year, month, date] = iso_0.split('-');
        let newIso = iso_0;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, $dFOvD.default)(new Date(parsedYear, parsedMonth - 1 // This needs to be -1, because the Date constructor expects an index of the given month
        )).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${year}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedMonth)}-${$4f412f3052943294$export$a7de57e5b672ccdb(lastDayInMonth)}`;
        else newIso = `${year}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedMonth)}-${$4f412f3052943294$export$a7de57e5b672ccdb(parsedDate)}`;
        setViewDate(newIso);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $buG8Z.default), {
        ...$4f412f3052943294$var$getValidDate(viewDate),
        minDate: minDate ? (0, $26dZt.formatIsoLocalDate)(minDate, locale) : undefined,
        maxDate: maxDate ? (0, $26dZt.formatIsoLocalDate)(maxDate, locale) : undefined,
        selected: [
            selectedDate || ''
        ],
        previouslySelected: previousSelectedDate ? [
            previousSelectedDate
        ] : [],
        onChange: (e)=>onChange(e.iso),
        onSelect: (e_0)=>onSelect(e_0.iso)
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevProps.date, nextProps.date));












var $hekY6 = parcelRequire("hekY6");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $8a5c1baadae52332$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



var $ejURJ = parcelRequire("ejURJ");


var $ljSu0 = parcelRequire("ljSu0");







var $1sCHt = parcelRequire("1sCHt");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");




var $4ez2K = parcelRequire("4ez2K");



var $4aRua = parcelRequire("4aRua");





var $amKSx = parcelRequire("amKSx");






const $47b59ce1bbdf7dc7$var$intervalOptionAriaLabel = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range-picker-content.interval-option-aria-label",
    defaultMessage: "{name}, {dateRange}"
});
const $47b59ce1bbdf7dc7$var$styles = {
    yearPickerPadding: "_2Zuz6Q2ADO _1Znuxb2ADO",
    intervalPickerWrapper: "_4c065U5zaO _2Y7lL45zaO"
};
const $47b59ce1bbdf7dc7$var$intervalPickerContainerStyles = null; /**
                                             * Resolves an IntervalOption's dates into the given display year,
                                             * returning the actual start and end Date objects for that year.
                                             */ 
function $47b59ce1bbdf7dc7$var$resolveIntervalDates(interval, year) {
    return {
        start: new Date(year, interval.startDate.getMonth(), interval.startDate.getDate()),
        end: new Date(year, interval.endDate.getMonth(), interval.endDate.getDate())
    };
} /**
   * Checks whether an interval (resolved to the display year) falls within a date range,
   * i.e. the interval's start is >= rangeStart and the interval's end is <= rangeEnd.
   */ 
function $47b59ce1bbdf7dc7$var$isIntervalInRange(interval, displayYear, rangeStart, rangeEnd) {
    const { start: start, end: end } = $47b59ce1bbdf7dc7$var$resolveIntervalDates(interval, displayYear);
    return start >= rangeStart && end <= rangeEnd;
}
const $47b59ce1bbdf7dc7$export$e2c8a770d777dfd1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(63);
    const { date: date, onSelect: onSelect, minDate: minDate, maxDate: maxDate, intervals: intervals, isRangeSelect: t0 } = props;
    const isRangeSelect = t0 === undefined ? false : t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== date || $[1] !== intervals[0]?.startDate) {
        t1 = ()=>date?.start ? (0, $ljSu0.default)((0, $amKSx.parseValueToLocalDate)(date.start)) : (0, $ljSu0.default)(intervals[0]?.startDate ?? new Date()) ?? (0, $ljSu0.default)(new Date());
        $[0] = date;
        $[1] = intervals[0]?.startDate;
        $[2] = t1;
    } else t1 = $[2];
    const [displayYear, setDisplayYear] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[3] !== date) {
        t2 = ()=>{
            if (date?.start) setDisplayYear((0, $ljSu0.default)((0, $amKSx.parseValueToLocalDate)(date.start)));
        };
        $[3] = date;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = date?.start;
    let t4;
    if ($[5] !== t3) {
        t4 = [
            t3
        ];
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    (0, $cozmU.useEffect)(t2, t4);
    let t5;
    if ($[7] !== date) {
        t5 = date?.start ? (0, $amKSx.parseValueToLocalDate)(date.start) : null;
        $[7] = date;
        $[8] = t5;
    } else t5 = $[8];
    const valueStart = t5;
    let t6;
    if ($[9] !== date) {
        t6 = date?.end ? (0, $amKSx.parseValueToLocalDate)(date.end) : null;
        $[9] = date;
        $[10] = t6;
    } else t6 = $[10];
    const valueEnd = t6;
    const locale = (0, $k0hOH.useDateLocale)();
    const [pendingRangeStart, setPendingRangeStart] = (0, $cozmU.useState)(null);
    let t7;
    if ($[11] !== displayYear || $[12] !== locale || $[13] !== onSelect) {
        t7 = (interval)=>{
            onSelect((0, $1soKT.intervalToDatePickerValue)(interval, displayYear, locale), interval);
        };
        $[11] = displayYear;
        $[12] = locale;
        $[13] = onSelect;
        $[14] = t7;
    } else t7 = $[14];
    const onDateChange = t7;
    let t8;
    if ($[15] !== displayYear || $[16] !== locale || $[17] !== onSelect || $[18] !== pendingRangeStart) {
        t8 = (interval_0)=>{
            const clicked = $47b59ce1bbdf7dc7$var$resolveIntervalDates(interval_0, displayYear);
            if (pendingRangeStart === null) setPendingRangeStart({
                date: clicked.start,
                interval: interval_0
            });
            else {
                if (clicked.start < pendingRangeStart.date) {
                    setPendingRangeStart({
                        date: clicked.start,
                        interval: interval_0
                    });
                    return;
                }
                const rangeValue = {
                    start: (0, $26dZt.formatIsoLocalDate)(pendingRangeStart.date, locale),
                    end: (0, $26dZt.formatIsoLocalDate)(clicked.end, locale)
                };
                const startInterval = pendingRangeStart.interval;
                const displayInterval = startInterval.name === interval_0.name ? interval_0 : {
                    ...startInterval,
                    name: `${startInterval.name} \u{2013} ${interval_0.name}`,
                    endDate: interval_0.endDate
                };
                setPendingRangeStart(null);
                onSelect(rangeValue, displayInterval);
            }
        };
        $[15] = displayYear;
        $[16] = locale;
        $[17] = onSelect;
        $[18] = pendingRangeStart;
        $[19] = t8;
    } else t8 = $[19];
    const onRangeDateChange = t8;
    let t9;
    if ($[20] !== maxDate || $[21] !== minDate) {
        t9 = (_isSelected, interval_1)=>{
            if (minDate && interval_1.endDate < minDate) return true;
            if (maxDate && interval_1.startDate > maxDate) return true;
            return false;
        };
        $[20] = maxDate;
        $[21] = minDate;
        $[22] = t9;
    } else t9 = $[22];
    const isIntervalDisabled = t9;
    let t10;
    if ($[23] !== displayYear || $[24] !== isRangeSelect || $[25] !== pendingRangeStart || $[26] !== valueEnd || $[27] !== valueStart) {
        t10 = (item)=>{
            if (!isRangeSelect) return valueStart != null && valueEnd != null && (0, $ljSu0.default)(valueStart) === displayYear && (0, $ejURJ.default)(valueStart) === (0, $ejURJ.default)(item.startDate) && (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(valueStart) === (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(item.startDate) && (0, $ejURJ.default)(valueEnd) === (0, $ejURJ.default)(item.endDate) && (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(valueEnd) === (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(item.endDate);
            if (pendingRangeStart !== null) {
                const { start: start } = $47b59ce1bbdf7dc7$var$resolveIntervalDates(item, displayYear);
                return start.getTime() === pendingRangeStart.date.getTime();
            }
            if (valueStart != null && valueEnd != null) return $47b59ce1bbdf7dc7$var$isIntervalInRange(item, displayYear, valueStart, valueEnd);
            return false;
        };
        $[23] = displayYear;
        $[24] = isRangeSelect;
        $[25] = pendingRangeStart;
        $[26] = valueEnd;
        $[27] = valueStart;
        $[28] = t10;
    } else t10 = $[28];
    const isIntervalSelected = t10;
    let t11;
    let t12;
    if ($[29] !== displayYear) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setDisplayYear(displayYear - 1),
            label: "Button to see previous year",
            icon: $47b59ce1bbdf7dc7$var$_temp
        });
        t12 = /*#__PURE__*/ $cozmU.createElement("b", null, displayYear);
        $[29] = displayYear;
        $[30] = t11;
        $[31] = t12;
    } else {
        t11 = $[30];
        t12 = $[31];
    }
    let t13;
    if ($[32] !== displayYear) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setDisplayYear(displayYear + 1),
            label: "Button to see next year",
            icon: $47b59ce1bbdf7dc7$var$_temp2
        });
        $[32] = displayYear;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $47b59ce1bbdf7dc7$var$styles.yearPickerPadding,
            testId: "year-picker-container"
        }, t11, t12, t13);
        $[34] = t11;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_2mHwu82ADO _3138425zaO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _0GwItXchRC _0jFU0VFpVx _1bplAbdnbC _0QiRqjdnbC _4FiyXSyie8 _1VtPS8w8kT _0FKoc6Q4SZ _2Wd78QDIqT _1V26qiDIqT _1NfdjGw8kT _3JOJs3w8kT"
        ]);
        $[38] = t15;
    } else t15 = $[38];
    let t16;
    if ($[39] !== displayYear || $[40] !== formatMessage || $[41] !== intervals || $[42] !== isIntervalDisabled || $[43] !== isIntervalSelected || $[44] !== isRangeSelect || $[45] !== locale || $[46] !== onDateChange || $[47] !== onRangeDateChange) {
        let t17;
        if ($[49] !== displayYear || $[50] !== formatMessage || $[51] !== isIntervalDisabled || $[52] !== isIntervalSelected || $[53] !== isRangeSelect || $[54] !== locale || $[55] !== onDateChange || $[56] !== onRangeDateChange) {
            t17 = (item_0)=>{
                const startInDisplayYear = new Date(displayYear, item_0.startDate.getMonth(), item_0.startDate.getDate());
                const endInDisplayYear = new Date(displayYear, item_0.endDate.getMonth(), item_0.endDate.getDate());
                const dateRangeLabel = `${(0, $26dZt.formatWithLocale)(startInDisplayYear, "MMM d", locale)} - ${(0, $26dZt.formatWithLocale)(endInDisplayYear, "MMM d", locale)}`;
                const isSelected = isIntervalSelected(item_0);
                return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                    key: `${item_0.startDate.getTime()}-${item_0.endDate.getTime()}`,
                    appearance: "subtle",
                    onClick: ()=>isRangeSelect ? onRangeDateChange(item_0) : onDateChange(item_0),
                    isSelected: isSelected,
                    "aria-checked": isSelected,
                    "aria-label": formatMessage($47b59ce1bbdf7dc7$var$intervalOptionAriaLabel, {
                        name: item_0.name,
                        dateRange: dateRangeLabel
                    }),
                    role: "radio",
                    isDisabled: isIntervalDisabled(isSelected, item_0)
                }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    as: "span",
                    alignInline: "center",
                    space: "space.025"
                }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    weight: "medium",
                    color: "inherit",
                    align: "center"
                }, item_0.name), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    size: "small",
                    color: "inherit",
                    align: "center"
                }, dateRangeLabel)));
            };
            $[49] = displayYear;
            $[50] = formatMessage;
            $[51] = isIntervalDisabled;
            $[52] = isIntervalSelected;
            $[53] = isRangeSelect;
            $[54] = locale;
            $[55] = onDateChange;
            $[56] = onRangeDateChange;
            $[57] = t17;
        } else t17 = $[57];
        t16 = intervals.map(t17);
        $[39] = displayYear;
        $[40] = formatMessage;
        $[41] = intervals;
        $[42] = isIntervalDisabled;
        $[43] = isIntervalSelected;
        $[44] = isRangeSelect;
        $[45] = locale;
        $[46] = onDateChange;
        $[47] = onRangeDateChange;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[58] !== t16) {
        t17 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "radiogroup",
            className: t15
        }, t16);
        $[58] = t16;
        $[59] = t17;
    } else t17 = $[59];
    let t18;
    if ($[60] !== t14 || $[61] !== t17) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $47b59ce1bbdf7dc7$var$styles.intervalPickerWrapper,
            testId: "interval-picker-wrapper"
        }, t14, t17);
        $[60] = t14;
        $[61] = t17;
        $[62] = t18;
    } else t18 = $[62];
    return t18;
} : (props)=>{
    const { date: date, onSelect: onSelect, minDate: minDate, maxDate: maxDate, intervals: intervals, isRangeSelect: isRangeSelect = false } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [displayYear, setDisplayYear] = (0, $cozmU.useState)(()=>date?.start ? (0, $ljSu0.default)((0, $amKSx.parseValueToLocalDate)(date.start)) : (0, $ljSu0.default)(intervals[0]?.startDate ?? new Date()) ?? (0, $ljSu0.default)(new Date()));
    (0, $cozmU.useEffect)(()=>{
        if (date?.start) setDisplayYear((0, $ljSu0.default)((0, $amKSx.parseValueToLocalDate)(date.start)));
    }, [
        date?.start
    ]);
    const valueStart = date?.start ? (0, $amKSx.parseValueToLocalDate)(date.start) : null;
    const valueEnd = date?.end ? (0, $amKSx.parseValueToLocalDate)(date.end) : null;
    const locale = (0, $k0hOH.useDateLocale)(); // Range selection state: stores the actual resolved start date and the
    // IntervalOption of the pending start. null means no pending start has been picked yet.
    const [pendingRangeStart, setPendingRangeStart] = (0, $cozmU.useState)(null);
    const onDateChange = (0, $cozmU.useCallback)((interval)=>{
        onSelect((0, $1soKT.intervalToDatePickerValue)(interval, displayYear, locale), interval);
    }, [
        displayYear,
        locale,
        onSelect
    ]);
    const onRangeDateChange = (0, $cozmU.useCallback)((interval_0)=>{
        const clicked = $47b59ce1bbdf7dc7$var$resolveIntervalDates(interval_0, displayYear);
        if (pendingRangeStart === null) // First click: store the actual start date and interval.
        setPendingRangeStart({
            date: clicked.start,
            interval: interval_0
        });
        else {
            // Second click: determine end.
            if (clicked.start < pendingRangeStart.date) {
                // Validation: if the clicked interval starts before the pending start,
                // treat it as a new start.
                setPendingRangeStart({
                    date: clicked.start,
                    interval: interval_0
                });
                return;
            }
            const rangeValue = {
                start: (0, $26dZt.formatIsoLocalDate)(pendingRangeStart.date, locale),
                end: (0, $26dZt.formatIsoLocalDate)(clicked.end, locale)
            }; // Build a combined display name for the range.
            // If start and end are the same interval, use just that name;
            // otherwise join them with an en-dash (e.g. "Period 1 – Period 3").
            const startInterval = pendingRangeStart.interval;
            const displayInterval = startInterval.name === interval_0.name ? interval_0 : {
                ...startInterval,
                name: `${startInterval.name} \u{2013} ${interval_0.name}`,
                endDate: interval_0.endDate
            };
            setPendingRangeStart(null);
            onSelect(rangeValue, displayInterval);
        }
    }, [
        pendingRangeStart,
        displayYear,
        locale,
        onSelect
    ]);
    const isIntervalDisabled = (0, $cozmU.useCallback)((_isSelected, interval_1)=>{
        if (minDate && interval_1.endDate < minDate) return true;
        if (maxDate && interval_1.startDate > maxDate) return true;
        return false;
    }, [
        minDate,
        maxDate
    ]); /**
                           * Determines whether an interval should be visually selected.
                           * In range-select mode, this includes the pending start interval
                           * and all intervals within a committed range.
                           */ 
    const isIntervalSelected = (0, $cozmU.useCallback)((item)=>{
        if (!isRangeSelect) // Single-select mode: match exact interval
        return valueStart != null && valueEnd != null && (0, $ljSu0.default)(valueStart) === displayYear && (0, $ejURJ.default)(valueStart) === (0, $ejURJ.default)(item.startDate) && (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(valueStart) === (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(item.startDate) && (0, $ejURJ.default)(valueEnd) === (0, $ejURJ.default)(item.endDate) && (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(valueEnd) === (0, $8a5c1baadae52332$export$2e2bcd8739ae039)(item.endDate);
         // Range-select mode
        if (pendingRangeStart !== null) {
            // Highlight the pending start interval
            const { start: start } = $47b59ce1bbdf7dc7$var$resolveIntervalDates(item, displayYear);
            return start.getTime() === pendingRangeStart.date.getTime();
        } // Show the committed range
        if (valueStart != null && valueEnd != null) return $47b59ce1bbdf7dc7$var$isIntervalInRange(item, displayYear, valueStart, valueEnd);
        return false;
    }, [
        isRangeSelect,
        valueStart,
        valueEnd,
        displayYear,
        pendingRangeStart
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $47b59ce1bbdf7dc7$var$styles.intervalPickerWrapper,
        testId: "interval-picker-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center",
        xcss: $47b59ce1bbdf7dc7$var$styles.yearPickerPadding,
        testId: "year-picker-container"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDisplayYear(displayYear - 1),
        label: "Button to see previous year",
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            })
    }), /*#__PURE__*/ $cozmU.createElement("b", null, displayYear), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDisplayYear(displayYear + 1),
        label: "Button to see next year",
        icon: (iconProps_0)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            })
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        role: "radiogroup",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3138425zaO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _0GwItXchRC _0jFU0VFpVx _1bplAbdnbC _0QiRqjdnbC _4FiyXSyie8 _1VtPS8w8kT _0FKoc6Q4SZ _2Wd78QDIqT _1V26qiDIqT _1NfdjGw8kT _3JOJs3w8kT"
        ])
    }, intervals.map((item_0)=>{
        const startInDisplayYear = new Date(displayYear, item_0.startDate.getMonth(), item_0.startDate.getDate());
        const endInDisplayYear = new Date(displayYear, item_0.endDate.getMonth(), item_0.endDate.getDate());
        const dateRangeLabel = `${(0, $26dZt.formatWithLocale)(startInDisplayYear, 'MMM d', locale)} - ${(0, $26dZt.formatWithLocale)(endInDisplayYear, 'MMM d', locale)}`;
        const isSelected = isIntervalSelected(item_0);
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            key: `${item_0.startDate.getTime()}-${item_0.endDate.getTime()}`,
            appearance: "subtle",
            onClick: ()=>isRangeSelect ? onRangeDateChange(item_0) : onDateChange(item_0),
            isSelected: isSelected,
            "aria-checked": isSelected,
            "aria-label": formatMessage($47b59ce1bbdf7dc7$var$intervalOptionAriaLabel, {
                name: item_0.name,
                dateRange: dateRangeLabel
            }),
            role: "radio",
            isDisabled: isIntervalDisabled(isSelected, item_0)
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            as: "span",
            alignInline: "center",
            space: "space.025"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium",
            color: "inherit",
            align: "center"
        }, item_0.name), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "inherit",
            align: "center"
        }, dateRangeLabel)));
    })));
};
function $47b59ce1bbdf7dc7$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $47b59ce1bbdf7dc7$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_0,
        size: "small"
    });
}


















var $6Mfv2 = parcelRequire("6Mfv2");


var $mr7nI = parcelRequire("mr7nI");




























const $3c8cff0e17e01672$var$yearPickerContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    marginBottom: 'space.200'
});
const $3c8cff0e17e01672$var$monthPickerContainerStyles = null;
const $3c8cff0e17e01672$var$monthPickerWrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.200'
});
const $3c8cff0e17e01672$var$getMonthNames = (locale)=>{
    const today = new Date();
    const months = [];
    for(let i = 0; i < 12; i++)months.push({
        month: i,
        name: (0, $26dZt.formatWithLocale)(new Date(today.getFullYear(), i), 'MMM', locale)
    });
    return months;
};
const $3c8cff0e17e01672$export$6e979f880d369f74 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(55);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $1soKT.getInitialMonthPickerDate)(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const [date, setDate] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[2] !== props.previousDate) {
        t1 = (0, $1soKT.getMonthPickerDate)(props.previousDate);
        $[2] = props.previousDate;
        $[3] = t1;
    } else t1 = $[3];
    const previousDate = t1;
    const locale = (0, $k0hOH.useDateLocale)();
    const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, withTimeScale: withTimeScale, minDate: minDate, maxDate: maxDate } = props;
    const { month: month, year: year, initialYear: initialYear } = date;
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[4] !== date.initialYear || $[5] !== dateType || $[6] !== initialYear || $[7] !== locale || $[8] !== maxDate || $[9] !== minDate || $[10] !== month || $[11] !== onSelect || $[12] !== previousDate || $[13] !== selectedDate || $[14] !== withTimeScale || $[15] !== year) {
        const MONTHS_DATA = $3c8cff0e17e01672$var$getMonthNames(locale);
        let t8;
        if ($[23] !== locale || $[24] !== onSelect) {
            t8 = (newDate)=>{
                setDate(newDate);
                const newDateObject = new Date(newDate.year, newDate.month);
                const newDateInterval = {
                    start: (0, $26dZt.formatIsoLocalDate)((0, $7IjeE.default)(newDateObject), locale),
                    end: (0, $26dZt.formatIsoLocalDate)((0, $WeoLw.default)(newDateObject), locale)
                };
                onSelect(newDateInterval);
            };
            $[23] = locale;
            $[24] = onSelect;
            $[25] = t8;
        } else t8 = $[25];
        const onDateChange = t8;
        let t9;
        if ($[26] !== dateType || $[27] !== maxDate || $[28] !== minDate || $[29] !== selectedDate || $[30] !== year) {
            t9 = (isSelected, monthItem)=>{
                const currentMonth = new Date(year, monthItem);
                const monthStart = (0, $7IjeE.default)(currentMonth);
                const monthEnd = (0, $WeoLw.default)(currentMonth);
                if (minDate && monthEnd < minDate) return true;
                if (maxDate && monthStart > maxDate) return true;
                if (!selectedDate) return false;
                return !isSelected && (dateType === "start" ? (0, $mr7nI.default)(selectedDate, currentMonth) : (0, $6Mfv2.default)(selectedDate, currentMonth));
            };
            $[26] = dateType;
            $[27] = maxDate;
            $[28] = minDate;
            $[29] = selectedDate;
            $[30] = year;
            $[31] = t9;
        } else t9 = $[31];
        const isMonthDisabled = t9;
        T0 = (0, $3izAL.Box);
        t6 = $3c8cff0e17e01672$var$monthPickerWrapperStyles;
        if ($[32] !== initialYear || $[33] !== month || $[34] !== withTimeScale || $[35] !== year) {
            t7 = withTimeScale && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
                xcss: $3c8cff0e17e01672$var$yearPickerContainerStyles,
                testId: "year-picker-container"
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                spacing: "compact",
                onClick: ()=>setDate({
                        initialYear: initialYear,
                        month: month,
                        year: year - 1
                    }),
                label: "Button to see previous year",
                icon: $3c8cff0e17e01672$var$_temp
            }), /*#__PURE__*/ $cozmU.createElement("b", null, year), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                spacing: "compact",
                onClick: ()=>setDate({
                        initialYear: initialYear,
                        month: month,
                        year: year + 1
                    }),
                label: "Button to see next year",
                icon: $3c8cff0e17e01672$var$_temp2
            }));
            $[32] = initialYear;
            $[33] = month;
            $[34] = withTimeScale;
            $[35] = year;
            $[36] = t7;
        } else t7 = $[36];
        t2 = "month-picker-container";
        t3 = "radiogroup";
        if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, $hekY6.default)([
                "_3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _1bplAbdnbC _0QiRqjdnbC _4FiyXSfsgx _1ZwhW7YbGa _1VtPS8G9sM _0a6hCI1Y8M _0B4DIBDIqT _2gIVr5Y9q9 _1pckVMZpcK"
            ]);
            $[37] = t4;
        } else t4 = $[37];
        let t10;
        if ($[38] !== date.initialYear || $[39] !== isMonthDisabled || $[40] !== month || $[41] !== onDateChange || $[42] !== previousDate || $[43] !== year) {
            t10 = (item)=>{
                const isSelected_0 = date.initialYear === year && month === item.month;
                const isPreviouslySelected = previousDate ? previousDate.year === year && previousDate.month === item.month : false;
                if (isPreviouslySelected) return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                    id: "previously-selected-month-option",
                    appearance: "subtle",
                    key: item.month,
                    testId: "previously-selected-month-option",
                    "aria-checked": false,
                    "aria-label": item.name,
                    role: "radio"
                }, item.name);
                return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                    key: item.month,
                    appearance: "subtle",
                    onClick: ()=>onDateChange({
                            initialYear: year,
                            year: year,
                            month: item.month
                        }),
                    isSelected: isSelected_0,
                    isDisabled: isMonthDisabled(isSelected_0, item.month),
                    testId: isSelected_0 ? "selected-month-option" : "month-option",
                    "aria-checked": isSelected_0,
                    "aria-label": item.name,
                    role: "radio"
                }, item.name);
            };
            $[38] = date.initialYear;
            $[39] = isMonthDisabled;
            $[40] = month;
            $[41] = onDateChange;
            $[42] = previousDate;
            $[43] = year;
            $[44] = t10;
        } else t10 = $[44];
        t5 = MONTHS_DATA.map(t10);
        $[4] = date.initialYear;
        $[5] = dateType;
        $[6] = initialYear;
        $[7] = locale;
        $[8] = maxDate;
        $[9] = minDate;
        $[10] = month;
        $[11] = onSelect;
        $[12] = previousDate;
        $[13] = selectedDate;
        $[14] = withTimeScale;
        $[15] = year;
        $[16] = T0;
        $[17] = t2;
        $[18] = t3;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else {
        T0 = $[16];
        t2 = $[17];
        t3 = $[18];
        t4 = $[19];
        t5 = $[20];
        t6 = $[21];
        t7 = $[22];
    }
    let t8;
    if ($[45] !== t2 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t2,
            role: t3,
            className: t4
        }, t5);
        $[45] = t2;
        $[46] = t3;
        $[47] = t4;
        $[48] = t5;
        $[49] = t8;
    } else t8 = $[49];
    let t9;
    if ($[50] !== T0 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t6
        }, t7, t8);
        $[50] = T0;
        $[51] = t6;
        $[52] = t7;
        $[53] = t8;
        $[54] = t9;
    } else t9 = $[54];
    return t9;
} : (props)=>{
    const [date, setDate] = (0, $cozmU.useState)((0, $1soKT.getInitialMonthPickerDate)(props));
    const previousDate = (0, $1soKT.getMonthPickerDate)(props.previousDate);
    const locale = (0, $k0hOH.useDateLocale)();
    const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, withTimeScale: withTimeScale, minDate: minDate, maxDate: maxDate } = props;
    const { month: month, year: year, initialYear: initialYear } = date;
    const MONTHS_DATA = $3c8cff0e17e01672$var$getMonthNames(locale);
    const onDateChange = (0, $cozmU.useCallback)((newDate)=>{
        setDate(newDate);
        const newDateObject = new Date(newDate.year, newDate.month);
        const newDateInterval = {
            start: (0, $26dZt.formatIsoLocalDate)((0, $7IjeE.default)(newDateObject), locale),
            end: (0, $26dZt.formatIsoLocalDate)((0, $WeoLw.default)(newDateObject), locale)
        };
        onSelect(newDateInterval);
    }, [
        onSelect,
        locale
    ]);
    const isMonthDisabled = (0, $cozmU.useCallback)((isSelected, monthItem)=>{
        const currentMonth = new Date(year, monthItem);
        const monthStart = (0, $7IjeE.default)(currentMonth);
        const monthEnd = (0, $WeoLw.default)(currentMonth);
        if (minDate && monthEnd < minDate) return true;
        if (maxDate && monthStart > maxDate) return true;
        if (!selectedDate) return false;
        return !isSelected && (dateType === 'start' ? (0, $mr7nI.default)(selectedDate, currentMonth) : (0, $6Mfv2.default)(selectedDate, currentMonth));
    }, [
        dateType,
        selectedDate,
        year,
        minDate,
        maxDate
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $3c8cff0e17e01672$var$monthPickerWrapperStyles
    }, withTimeScale && /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $3c8cff0e17e01672$var$yearPickerContainerStyles,
        testId: "year-picker-container"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDate({
                initialYear: initialYear,
                month: month,
                year: year - 1
            }),
        label: "Button to see previous year",
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            })
    }), /*#__PURE__*/ $cozmU.createElement("b", null, year), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDate({
                initialYear: initialYear,
                month: month,
                year: year + 1
            }),
        label: "Button to see next year",
        icon: (iconProps_0)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            })
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "month-picker-container",
        role: "radiogroup",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _1bplAbdnbC _0QiRqjdnbC _4FiyXSfsgx _1ZwhW7YbGa _1VtPS8G9sM _0a6hCI1Y8M _0B4DIBDIqT _2gIVr5Y9q9 _1pckVMZpcK"
        ])
    }, MONTHS_DATA.map((item)=>{
        const isSelected_0 = date.initialYear === year && month === item.month;
        const isPreviouslySelected = previousDate ? previousDate.year === year && previousDate.month === item.month : false;
        if (isPreviouslySelected) return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            id: "previously-selected-month-option",
            appearance: "subtle",
            key: item.month,
            testId: "previously-selected-month-option",
            "aria-checked": false,
            "aria-label": item.name,
            role: "radio"
        }, item.name);
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            key: item.month,
            appearance: "subtle",
            onClick: ()=>onDateChange({
                    initialYear: year,
                    year: year,
                    month: item.month
                }),
            isSelected: isSelected_0,
            isDisabled: isMonthDisabled(isSelected_0, item.month),
            testId: isSelected_0 ? 'selected-month-option' : 'month-option',
            "aria-checked": isSelected_0,
            "aria-label": item.name,
            role: "radio"
        }, item.name);
    })));
};
function $3c8cff0e17e01672$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $3c8cff0e17e01672$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_0,
        size: "small"
    });
}
























var $clx8d = parcelRequire("clx8d");


























const $9ab77b762873969a$var$yearPickerContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $9ab77b762873969a$var$quarterPickerContainerStyles = null;
const $9ab77b762873969a$var$quarterPickerWrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.200'
});
const $9ab77b762873969a$var$getQuarterData = (locale)=>{
    const today = new Date();
    const quarters = [];
    for(let i = 0; i < 12; i += 3)quarters.push({
        months: [
            i,
            i + 1,
            i + 2
        ],
        name: `${(0, $26dZt.formatWithLocale)(new Date(today.getFullYear(), i), 'MMM', locale)}-${(0, $26dZt.formatWithLocale)(new Date(today.getFullYear(), i + 2), 'MMM', locale)}`
    });
    return quarters;
};
const $9ab77b762873969a$export$1f3b9af4e880de43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(46);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $1soKT.getInitialMonthPickerDate)(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const [date, setDate] = (0, $cozmU.useState)(t0);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[2] !== date || $[3] !== props) {
        const previousDate = (0, $1soKT.getMonthPickerDate)(props.previousDate);
        const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, minDate: minDate, maxDate: maxDate } = props;
        const { month: month, year: year, initialYear: initialYear } = date;
        const locale = (0, $clx8d.default);
        let t8;
        if ($[12] !== onSelect) {
            t8 = (newDate)=>{
                setDate(newDate);
                const newDateObject = new Date(newDate.year, newDate.month);
                const newDateInterval = {
                    start: (0, $26dZt.formatIsoLocalDate)((0, $bUydO.default)(newDateObject), (0, $clx8d.default)),
                    end: (0, $26dZt.formatIsoLocalDate)((0, $2mU4K.default)(newDateObject), (0, $clx8d.default))
                };
                onSelect(newDateInterval);
            };
            $[12] = onSelect;
            $[13] = t8;
        } else t8 = $[13];
        const onDateChange = t8;
        const QUARTER_DATA = $9ab77b762873969a$var$getQuarterData((0, $clx8d.default));
        let t9;
        if ($[14] !== dateType || $[15] !== maxDate || $[16] !== minDate || $[17] !== selectedDate || $[18] !== year) {
            t9 = (isSelected, endQuarter)=>{
                const currentQuarter = new Date(year, endQuarter);
                const quarterStart = (0, $bUydO.default)(currentQuarter);
                const quarterEnd = (0, $2mU4K.default)(currentQuarter);
                if (minDate || maxDate) {
                    if (minDate && quarterEnd < minDate) return true;
                    if (maxDate && quarterStart > maxDate) return true;
                }
                if (!selectedDate) return false;
                const currentDate = new Date(year, endQuarter);
                return !isSelected && (dateType === "start" ? (0, $mr7nI.default)(selectedDate, currentDate) : (0, $6Mfv2.default)(selectedDate, currentDate));
            };
            $[14] = dateType;
            $[15] = maxDate;
            $[16] = minDate;
            $[17] = selectedDate;
            $[18] = year;
            $[19] = t9;
        } else t9 = $[19];
        const isQuarterDisabled = t9;
        T0 = (0, $3izAL.Box);
        t5 = $9ab77b762873969a$var$quarterPickerWrapperStyles;
        t6 = "quarter-picker-wrapper";
        let t10;
        if ($[20] !== initialYear || $[21] !== month || $[22] !== year) {
            t10 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                spacing: "compact",
                onClick: ()=>setDate({
                        initialYear: initialYear,
                        month: month,
                        year: year - 1
                    }),
                label: "Button to see previous year",
                icon: $9ab77b762873969a$var$_temp
            });
            $[20] = initialYear;
            $[21] = month;
            $[22] = year;
            $[23] = t10;
        } else t10 = $[23];
        let t11;
        if ($[24] !== year) {
            t11 = /*#__PURE__*/ $cozmU.createElement("b", null, year);
            $[24] = year;
            $[25] = t11;
        } else t11 = $[25];
        let t12;
        if ($[26] !== initialYear || $[27] !== month || $[28] !== year) {
            t12 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                spacing: "compact",
                onClick: ()=>setDate({
                        initialYear: initialYear,
                        month: month,
                        year: year + 1
                    }),
                label: "Button to see next year",
                icon: $9ab77b762873969a$var$_temp2
            });
            $[26] = initialYear;
            $[27] = month;
            $[28] = year;
            $[29] = t12;
        } else t12 = $[29];
        if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
                xcss: $9ab77b762873969a$var$yearPickerContainerStyles,
                testId: "year-picker-container"
            }, t10, t11, t12);
            $[30] = t10;
            $[31] = t11;
            $[32] = t12;
            $[33] = t7;
        } else t7 = $[33];
        t1 = "quarter-picker-container";
        t2 = "radiogroup";
        if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $hekY6.default)([
                "_3138425zaO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _0jFU0VFpVx _1bplAbdnbC _0QiRqjdnbC _4FiyXS715P _1VtPS8w8kT _1NfdjGw8kT _3JOJs3w8kT _0B4DIBDIqT _11i7fCY9q9 _2RZrLMZpcK"
            ]);
            $[34] = t3;
        } else t3 = $[34];
        t4 = QUARTER_DATA.map((item)=>{
            const startQuarter = item.months[0];
            const endQuarter_0 = item.months[2];
            const isSelected_0 = date.initialYear === year && item.months.includes(month);
            const isPreviouslySelected = previousDate ? previousDate.year === year && item.months.includes(previousDate.month) : false;
            if (isPreviouslySelected) return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                id: "previously-selected-quarter-option",
                appearance: "subtle",
                key: startQuarter,
                testId: "previously-selected-quarter-option",
                "aria-checked": false,
                "aria-label": item.name,
                role: "radio"
            }, item.name);
            return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                key: startQuarter,
                appearance: "subtle",
                onClick: ()=>onDateChange({
                        initialYear: year,
                        year: year,
                        month: endQuarter_0
                    }),
                isSelected: isSelected_0,
                "aria-checked": isSelected_0,
                "aria-label": item.name,
                role: "radio",
                isDisabled: isQuarterDisabled(isSelected_0, endQuarter_0)
            }, item.name);
        });
        $[2] = date;
        $[3] = props;
        $[4] = T0;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else {
        T0 = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
        t7 = $[11];
    }
    let t8;
    if ($[35] !== t1 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": t1,
            role: t2,
            className: t3
        }, t4);
        $[35] = t1;
        $[36] = t2;
        $[37] = t3;
        $[38] = t4;
        $[39] = t8;
    } else t8 = $[39];
    let t9;
    if ($[40] !== T0 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t5,
            testId: t6
        }, t7, t8);
        $[40] = T0;
        $[41] = t5;
        $[42] = t6;
        $[43] = t7;
        $[44] = t8;
        $[45] = t9;
    } else t9 = $[45];
    return t9;
} : (props)=>{
    const [date, setDate] = (0, $cozmU.useState)((0, $1soKT.getInitialMonthPickerDate)(props));
    const previousDate = (0, $1soKT.getMonthPickerDate)(props.previousDate);
    const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, minDate: minDate, maxDate: maxDate } = props;
    const { month: month, year: year, initialYear: initialYear } = date;
    const locale = (0, $clx8d.default);
    const onDateChange = (0, $cozmU.useCallback)((newDate)=>{
        setDate(newDate);
        const newDateObject = new Date(newDate.year, newDate.month);
        const newDateInterval = {
            start: (0, $26dZt.formatIsoLocalDate)((0, $bUydO.default)(newDateObject), locale),
            end: (0, $26dZt.formatIsoLocalDate)((0, $2mU4K.default)(newDateObject), locale)
        };
        onSelect(newDateInterval);
    }, [
        locale,
        onSelect
    ]);
    const QUARTER_DATA = $9ab77b762873969a$var$getQuarterData(locale);
    const isQuarterDisabled = (0, $cozmU.useCallback)((isSelected, endQuarter)=>{
        const currentQuarter = new Date(year, endQuarter);
        const quarterStart = (0, $bUydO.default)(currentQuarter);
        const quarterEnd = (0, $2mU4K.default)(currentQuarter);
        if (minDate || maxDate) {
            if (minDate && quarterEnd < minDate) return true;
            if (maxDate && quarterStart > maxDate) return true;
        }
        if (!selectedDate) return false;
        const currentDate = new Date(year, endQuarter);
        return !isSelected && (dateType === 'start' ? (0, $mr7nI.default)(selectedDate, currentDate) : (0, $6Mfv2.default)(selectedDate, currentDate));
    }, [
        dateType,
        selectedDate,
        year,
        minDate,
        maxDate
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $9ab77b762873969a$var$quarterPickerWrapperStyles,
        testId: "quarter-picker-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.Box), {
        xcss: $9ab77b762873969a$var$yearPickerContainerStyles,
        testId: "year-picker-container"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDate({
                initialYear: initialYear,
                month: month,
                year: year - 1
            }),
        label: "Button to see previous year",
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            })
    }), /*#__PURE__*/ $cozmU.createElement("b", null, year), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setDate({
                initialYear: initialYear,
                month: month,
                year: year + 1
            }),
        label: "Button to see next year",
        icon: (iconProps_0)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps_0,
                size: "small"
            })
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "quarter-picker-container",
        role: "radiogroup",
        className: (0, $hekY6.default)([
            "_3138425zaO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuxEoi _0jFU0VFpVx _1bplAbdnbC _0QiRqjdnbC _4FiyXS715P _1VtPS8w8kT _1NfdjGw8kT _3JOJs3w8kT _0B4DIBDIqT _11i7fCY9q9 _2RZrLMZpcK"
        ])
    }, QUARTER_DATA.map((item)=>{
        const startQuarter = item.months[0];
        const endQuarter_0 = item.months[2];
        const isSelected_0 = date.initialYear === year && item.months.includes(month);
        const isPreviouslySelected = previousDate ? previousDate.year === year && item.months.includes(previousDate.month) : false;
        if (isPreviouslySelected) return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            id: "previously-selected-quarter-option",
            appearance: "subtle",
            key: startQuarter,
            testId: "previously-selected-quarter-option",
            "aria-checked": false,
            "aria-label": item.name,
            role: "radio"
        }, item.name);
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            key: startQuarter,
            appearance: "subtle",
            onClick: ()=>onDateChange({
                    initialYear: year,
                    year: year,
                    month: endQuarter_0
                }),
            isSelected: isSelected_0,
            "aria-checked": isSelected_0,
            "aria-label": item.name,
            role: "radio",
            isDisabled: isQuarterDisabled(isSelected_0, endQuarter_0)
        }, item.name);
    })));
};
function $9ab77b762873969a$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        ...iconProps,
        size: "small"
    });
}
function $9ab77b762873969a$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps_0,
        size: "small"
    });
}


const $a444c97e41712140$var$quarterPickerButtonMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range-picker-content.quarter-picker-button-message",
    defaultMessage: "Quarter"
});
const $a444c97e41712140$var$monthPickerButtonMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range-picker-content.month-picker-button-message",
    defaultMessage: "Month"
});
const $a444c97e41712140$var$dayPickerButtonMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range-picker-content.day-picker-button-message",
    defaultMessage: "Day"
});
const $a444c97e41712140$var$intervalPickerButtonMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range-picker-content.interval-picker-button-message",
    defaultMessage: "Interval"
});
const $a444c97e41712140$var$buttonGroupStyles = (0, $buxP3.xcss)({
    padding: 'space.250',
    display: 'grid',
    gap: 'space.050',
    gridTemplateColumns: 'repeat(3, 1fr)',
    justifyContent: 'center'
});
const $a444c97e41712140$var$datePickerContentWrapperStyles = (0, $buxP3.xcss)({
    width: '322px'
});
const $a444c97e41712140$var$DEFAULT_GRANULARITIES = [
    (0, $1soKT.DateRangeScale).DAY,
    (0, $1soKT.DateRangeScale).MONTH,
    (0, $1soKT.DateRangeScale).QUARTER
];
const $a444c97e41712140$var$getDateValueForScale = (endDateIso, newScale, locale)=>{
    const endDate = (0, $k5sGX.default)(endDateIso);
    switch(newScale){
        case (0, $1soKT.DateRangeScale).DAY:
            return {
                start: endDateIso,
                end: endDateIso
            };
        case (0, $1soKT.DateRangeScale).MONTH:
            {
                const start = (0, $26dZt.formatIsoLocalDate)((0, $7IjeE.default)(endDate), locale);
                const end = (0, $26dZt.formatIsoLocalDate)((0, $WeoLw.default)(endDate), locale);
                return {
                    start: start,
                    end: end
                };
            }
        case (0, $1soKT.DateRangeScale).QUARTER:
            {
                const start = (0, $26dZt.formatIsoLocalDate)((0, $bUydO.default)(endDate), locale);
                const end = (0, $26dZt.formatIsoLocalDate)((0, $2mU4K.default)(endDate), locale);
                return {
                    start: start,
                    end: end
                };
            }
        default:
            return undefined;
    }
};
const $a444c97e41712140$var$DateRangePickerContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { withTimeScale: t1, defaultRangeScale: t2, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, isRangeSelect: isRangeSelect, ...props } = t0;
    const withTimeScale = t1 === undefined ? true : t1;
    const defaultRangeScale = t2 === undefined ? (0, $1soKT.DateRangeScale).MONTH : t2;
    const { value: date } = props;
    const { previousValue: previousDate } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const locale = (0, $k0hOH.useDateLocale)();
    const availableGranularities = granularities ?? [
        ...$a444c97e41712140$var$DEFAULT_GRANULARITIES
    ];
    const getInitialScale = ()=>{
        if (date) {
            const detectedScale = (0, $1soKT.getDateRangeScale)(date);
            return availableGranularities.includes(detectedScale) ? detectedScale : availableGranularities[0];
        }
        return availableGranularities.includes(defaultRangeScale) ? defaultRangeScale : availableGranularities[0];
    };
    const previousDateScale = previousDate ? (0, $1soKT.getDateRangeScale)(previousDate) : undefined;
    const [scale, setScale] = (0, $cozmU.useState)(getInitialScale());
    let t3;
    if ($[0] !== props || $[1] !== scale) {
        t3 = (newDate, selectedInterval)=>{
            if (newDate) props.onChange(newDate, scale, selectedInterval, (0, $8d907002e8695178$export$d19e7d63e5f456d1).DATE_SELECT);
        };
        $[0] = props;
        $[1] = scale;
        $[2] = t3;
    } else t3 = $[2];
    const onChange = t3;
    let t4;
    if ($[3] !== date || $[4] !== locale || $[5] !== props) {
        t4 = (newScale)=>{
            setScale(newScale);
            if (date) {
                const newValue = $a444c97e41712140$var$getDateValueForScale(date.end, newScale, locale);
                if (newValue) props.onChange(newValue, newScale, undefined, (0, $8d907002e8695178$export$d19e7d63e5f456d1).SCALE_SELECT);
            }
        };
        $[3] = date;
        $[4] = locale;
        $[5] = props;
        $[6] = t4;
    } else t4 = $[6];
    const onScaleChange = t4;
    const dateValue = date ? date.end : undefined;
    const previousDateValue = previousDate ? previousDate.end : undefined;
    let t5;
    if ($[7] !== availableGranularities) {
        t5 = (granularity)=>availableGranularities.includes(granularity);
        $[7] = availableGranularities;
        $[8] = t5;
    } else t5 = $[8];
    const shouldShowGranularity = t5;
    const shouldShowSwitcher = withTimeScale && availableGranularities.length > 1;
    let t6;
    if ($[9] !== formatMessage || $[10] !== onScaleChange || $[11] !== scale || $[12] !== shouldShowGranularity || $[13] !== shouldShowSwitcher) {
        t6 = shouldShowSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a444c97e41712140$var$buttonGroupStyles
        }, shouldShowGranularity((0, $1soKT.DateRangeScale).DAY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isSelected: scale === (0, $1soKT.DateRangeScale).DAY,
            onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).DAY),
            testId: "day-picker-button",
            "aria-label": (0, $1soKT.DateRangeScale).DAY,
            "aria-selected": scale === (0, $1soKT.DateRangeScale).DAY,
            role: "tab"
        }, formatMessage($a444c97e41712140$var$dayPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).MONTH) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isSelected: scale === (0, $1soKT.DateRangeScale).MONTH,
            onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).MONTH),
            testId: "month-picker-button",
            "aria-label": (0, $1soKT.DateRangeScale).MONTH,
            "aria-selected": scale === (0, $1soKT.DateRangeScale).MONTH,
            role: "tab"
        }, formatMessage($a444c97e41712140$var$monthPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).QUARTER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isSelected: scale === (0, $1soKT.DateRangeScale).QUARTER,
            onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).QUARTER),
            testId: "quarter-picker-button",
            "aria-label": (0, $1soKT.DateRangeScale).QUARTER,
            "aria-selected": scale === (0, $1soKT.DateRangeScale).QUARTER,
            role: "tab"
        }, formatMessage($a444c97e41712140$var$quarterPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).INTERVAL) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            isSelected: scale === (0, $1soKT.DateRangeScale).INTERVAL,
            onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).INTERVAL),
            testId: "interval-picker-button",
            "aria-label": (0, $1soKT.DateRangeScale).INTERVAL,
            "aria-selected": scale === (0, $1soKT.DateRangeScale).INTERVAL,
            role: "tab"
        }, formatMessage($a444c97e41712140$var$intervalPickerButtonMessage)));
        $[9] = formatMessage;
        $[10] = onScaleChange;
        $[11] = scale;
        $[12] = shouldShowGranularity;
        $[13] = shouldShowSwitcher;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "date-picker-button-wrapper",
            role: "tablist"
        }, t6);
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== dateValue || $[18] !== maxDate || $[19] !== minDate || $[20] !== onChange || $[21] !== previousDateScale || $[22] !== previousDateValue || $[23] !== scale) {
        t8 = scale === (0, $1soKT.DateRangeScale).DAY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f412f3052943294$export$97e6db89a86ff7ab), {
            date: dateValue,
            previousDate: previousDateScale === (0, $1soKT.DateRangeScale).DAY ? previousDateValue : undefined,
            onSelect: onChange,
            minDate: minDate,
            maxDate: maxDate
        });
        $[17] = dateValue;
        $[18] = maxDate;
        $[19] = minDate;
        $[20] = onChange;
        $[21] = previousDateScale;
        $[22] = previousDateValue;
        $[23] = scale;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== dateValue || $[26] !== maxDate || $[27] !== minDate || $[28] !== onChange || $[29] !== previousDateScale || $[30] !== previousDateValue || $[31] !== scale || $[32] !== withTimeScale) {
        t9 = scale === (0, $1soKT.DateRangeScale).MONTH && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3c8cff0e17e01672$export$6e979f880d369f74), {
            date: dateValue,
            previousDate: previousDateScale === (0, $1soKT.DateRangeScale).MONTH ? previousDateValue : undefined,
            onSelect: onChange,
            withTimeScale: withTimeScale,
            minDate: minDate,
            maxDate: maxDate
        });
        $[25] = dateValue;
        $[26] = maxDate;
        $[27] = minDate;
        $[28] = onChange;
        $[29] = previousDateScale;
        $[30] = previousDateValue;
        $[31] = scale;
        $[32] = withTimeScale;
        $[33] = t9;
    } else t9 = $[33];
    let t10;
    if ($[34] !== dateValue || $[35] !== maxDate || $[36] !== minDate || $[37] !== onChange || $[38] !== previousDateScale || $[39] !== previousDateValue || $[40] !== scale) {
        t10 = scale === (0, $1soKT.DateRangeScale).QUARTER && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ab77b762873969a$export$1f3b9af4e880de43), {
            date: dateValue,
            previousDate: previousDateScale === (0, $1soKT.DateRangeScale).QUARTER ? previousDateValue : undefined,
            onSelect: onChange,
            minDate: minDate,
            maxDate: maxDate
        });
        $[34] = dateValue;
        $[35] = maxDate;
        $[36] = minDate;
        $[37] = onChange;
        $[38] = previousDateScale;
        $[39] = previousDateValue;
        $[40] = scale;
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== date || $[43] !== intervals || $[44] !== isRangeSelect || $[45] !== maxDate || $[46] !== minDate || $[47] !== onChange || $[48] !== scale) {
        t11 = scale === (0, $1soKT.DateRangeScale).INTERVAL && intervals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47b59ce1bbdf7dc7$export$e2c8a770d777dfd1), {
            date: date,
            onSelect: (newDate_0, selectedInterval_0)=>newDate_0 && onChange(newDate_0, selectedInterval_0),
            minDate: minDate,
            maxDate: maxDate,
            intervals: intervals,
            isRangeSelect: isRangeSelect
        });
        $[42] = date;
        $[43] = intervals;
        $[44] = isRangeSelect;
        $[45] = maxDate;
        $[46] = minDate;
        $[47] = onChange;
        $[48] = scale;
        $[49] = t11;
    } else t11 = $[49];
    let t12;
    if ($[50] !== t10 || $[51] !== t11 || $[52] !== t8 || $[53] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "date-picker-content-wrapper"
        }, t8, t9, t10, t11);
        $[50] = t10;
        $[51] = t11;
        $[52] = t8;
        $[53] = t9;
        $[54] = t12;
    } else t12 = $[54];
    let t13;
    if ($[55] !== t12 || $[56] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $a444c97e41712140$var$datePickerContentWrapperStyles
        }, t7, t12);
        $[55] = t12;
        $[56] = t7;
        $[57] = t13;
    } else t13 = $[57];
    return t13;
} : ({ withTimeScale: withTimeScale = true, defaultRangeScale: defaultRangeScale = (0, $1soKT.DateRangeScale).MONTH, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, isRangeSelect: isRangeSelect, ...props })=>{
    const { value: date } = props;
    const { previousValue: previousDate } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const locale = (0, $k0hOH.useDateLocale)();
    const availableGranularities = granularities ?? [
        ...$a444c97e41712140$var$DEFAULT_GRANULARITIES
    ];
    const getInitialScale = ()=>{
        if (date) {
            const detectedScale = (0, $1soKT.getDateRangeScale)(date);
            return availableGranularities.includes(detectedScale) ? detectedScale : availableGranularities[0];
        }
        return availableGranularities.includes(defaultRangeScale) ? defaultRangeScale : availableGranularities[0];
    };
    const previousDateScale = previousDate ? (0, $1soKT.getDateRangeScale)(previousDate) : undefined;
    const [scale, setScale] = (0, $cozmU.useState)(getInitialScale());
    const onChange = (0, $cozmU.useCallback)((newDate, selectedInterval)=>{
        if (newDate) props.onChange(newDate, scale, selectedInterval, (0, $8d907002e8695178$export$d19e7d63e5f456d1).DATE_SELECT);
    }, [
        props,
        scale
    ]);
    const onScaleChange = (0, $cozmU.useCallback)((newScale)=>{
        setScale(newScale);
        if (date) {
            const newValue = $a444c97e41712140$var$getDateValueForScale(date.end, newScale, locale);
            if (newValue) props.onChange(newValue, newScale, undefined, (0, $8d907002e8695178$export$d19e7d63e5f456d1).SCALE_SELECT);
        }
    }, [
        date,
        locale,
        props
    ]);
    const dateValue = date ? date.end : undefined;
    const previousDateValue = previousDate ? previousDate.end : undefined;
    const shouldShowGranularity = (granularity)=>availableGranularities.includes(granularity);
    const shouldShowSwitcher = withTimeScale && availableGranularities.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a444c97e41712140$var$datePickerContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        testId: "date-picker-button-wrapper",
        role: "tablist"
    }, shouldShowSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $a444c97e41712140$var$buttonGroupStyles
    }, shouldShowGranularity((0, $1soKT.DateRangeScale).DAY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isSelected: scale === (0, $1soKT.DateRangeScale).DAY,
        onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).DAY),
        testId: "day-picker-button",
        "aria-label": (0, $1soKT.DateRangeScale).DAY,
        "aria-selected": scale === (0, $1soKT.DateRangeScale).DAY,
        role: "tab"
    }, formatMessage($a444c97e41712140$var$dayPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).MONTH) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isSelected: scale === (0, $1soKT.DateRangeScale).MONTH,
        onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).MONTH),
        testId: "month-picker-button",
        "aria-label": (0, $1soKT.DateRangeScale).MONTH,
        "aria-selected": scale === (0, $1soKT.DateRangeScale).MONTH,
        role: "tab"
    }, formatMessage($a444c97e41712140$var$monthPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).QUARTER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isSelected: scale === (0, $1soKT.DateRangeScale).QUARTER,
        onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).QUARTER),
        testId: "quarter-picker-button",
        "aria-label": (0, $1soKT.DateRangeScale).QUARTER,
        "aria-selected": scale === (0, $1soKT.DateRangeScale).QUARTER,
        role: "tab"
    }, formatMessage($a444c97e41712140$var$quarterPickerButtonMessage)), shouldShowGranularity((0, $1soKT.DateRangeScale).INTERVAL) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        isSelected: scale === (0, $1soKT.DateRangeScale).INTERVAL,
        onClick: ()=>onScaleChange((0, $1soKT.DateRangeScale).INTERVAL),
        testId: "interval-picker-button",
        "aria-label": (0, $1soKT.DateRangeScale).INTERVAL,
        "aria-selected": scale === (0, $1soKT.DateRangeScale).INTERVAL,
        role: "tab"
    }, formatMessage($a444c97e41712140$var$intervalPickerButtonMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        testId: "date-picker-content-wrapper"
    }, scale === (0, $1soKT.DateRangeScale).DAY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f412f3052943294$export$97e6db89a86ff7ab), {
        date: dateValue,
        previousDate: previousDateScale === (0, $1soKT.DateRangeScale).DAY ? previousDateValue : undefined,
        onSelect: onChange,
        minDate: minDate,
        maxDate: maxDate
    }), scale === (0, $1soKT.DateRangeScale).MONTH && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3c8cff0e17e01672$export$6e979f880d369f74), {
        date: dateValue,
        previousDate: previousDateScale === (0, $1soKT.DateRangeScale).MONTH ? previousDateValue : undefined,
        onSelect: onChange,
        withTimeScale: withTimeScale,
        minDate: minDate,
        maxDate: maxDate
    }), scale === (0, $1soKT.DateRangeScale).QUARTER && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ab77b762873969a$export$1f3b9af4e880de43), {
        date: dateValue,
        previousDate: previousDateScale === (0, $1soKT.DateRangeScale).QUARTER ? previousDateValue : undefined,
        onSelect: onChange,
        minDate: minDate,
        maxDate: maxDate
    }), scale === (0, $1soKT.DateRangeScale).INTERVAL && intervals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47b59ce1bbdf7dc7$export$e2c8a770d777dfd1), {
        date: date,
        onSelect: (newDate_0, selectedInterval_0)=>newDate_0 && onChange(newDate_0, selectedInterval_0),
        minDate: minDate,
        maxDate: maxDate,
        intervals: intervals,
        isRangeSelect: isRangeSelect
    })));
};
var $a444c97e41712140$export$2e2bcd8739ae039 = $a444c97e41712140$var$DateRangePickerContent;


const $a8b8832c37e6865f$var$confirmButtonMessage = (0, $kSwu1.defineMessage)({
    id: "townsquare.date-range-picker.confirmation.confirm",
    defaultMessage: "Confirm"
});
const $a8b8832c37e6865f$var$cancelButtonMessage = (0, $kSwu1.defineMessage)({
    id: "townsquare.date-range-picker.confirmation.cancel",
    defaultMessage: "Cancel"
});
const $a8b8832c37e6865f$var$styles = {
    confirmationMessage: "_2Y7lL4kG2W _0xmtkokG2W",
    confirmButtons: "_2Y7lL4kG2W _0xmtkokG2W",
    popupHeader: "_2Y7lL4kG2W _46hvQmkG2W"
};
const $a8b8832c37e6865f$export$17334619f3ac2224 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(60);
    const { value: value, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, onClose: onClose, withTimeScale: t0, appearance: t1, disabled: t2, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, intervalValue: intervalValue, selectIconPlacement: t3, size: size, isRangeSelect: isRangeSelect, confirmationMessage: confirmationMessage, displayConfirmationButtons: t4, shouldCommitSelection: t5, subtitle: subtitle, description: description } = props;
    const withTimeScale = t0 === undefined ? true : t0;
    const appearance = t1 === undefined ? "default" : t1;
    const disabled = t2 === undefined ? false : t2;
    const selectIconPlacement = t3 === undefined ? "end" : t3;
    const displayConfirmationButtons = t4 === undefined ? false : t4;
    const shouldCommitSelection = t5 === undefined ? true : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isControlled = "value" in props;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $iDrrr.fg)("goal_types_m3_bundled_updates");
        $[0] = t6;
    } else t6 = $[0];
    const isBundledUpdatesEnabled = t6;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [currentValue, setCurentValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(value ?? defaultValue);
    const [selectedInterval, setSelectedInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(intervalValue);
    const [pendingValue, setPendingValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const locale = (0, $k0hOH.useDateLocale)();
    let t7;
    let t8;
    if ($[1] !== isControlled || $[2] !== value) {
        t7 = ()=>{
            if (isControlled) setCurentValue(value);
        };
        t8 = [
            value,
            isControlled
        ];
        $[1] = isControlled;
        $[2] = value;
        $[3] = t7;
        $[4] = t8;
    } else {
        t7 = $[3];
        t8 = $[4];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t7, t8);
    let t10;
    let t9;
    if ($[5] !== intervalValue || $[6] !== locale) {
        t9 = ()=>{
            if ((0, $iDrrr.fg)("mercury_web_enable_intervals")) {
                if (intervalValue) setCurentValue((0, $1soKT.intervalToDatePickerValue)(intervalValue, intervalValue.startDate.getFullYear(), locale));
                setSelectedInterval(intervalValue);
            }
        };
        t10 = [
            intervalValue,
            locale
        ];
        $[5] = intervalValue;
        $[6] = locale;
        $[7] = t10;
        $[8] = t9;
    } else {
        t10 = $[7];
        t9 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t9, t10);
    let t11;
    if ($[9] !== disabled || $[10] !== isOpen || $[11] !== onClose) {
        t11 = ()=>{
            if (!disabled) {
                if (isOpen) onClose?.();
                setIsOpen(!isOpen);
            }
        };
        $[9] = disabled;
        $[10] = isOpen;
        $[11] = onClose;
        $[12] = t11;
    } else t11 = $[12];
    const togglePopup = t11;
    let t12;
    if ($[13] !== onClose) {
        t12 = ()=>{
            setIsOpen(false);
            setPendingValue(undefined);
            onClose?.();
        };
        $[13] = onClose;
        $[14] = t12;
    } else t12 = $[14];
    const closePopup = t12;
    let t13;
    if ($[15] !== displayConfirmationButtons || $[16] !== onChange || $[17] !== onClose || $[18] !== shouldCommitSelection) {
        t13 = (newValue, confidence, newSelectedInterval, source)=>{
            if (source === (0, $8d907002e8695178$export$d19e7d63e5f456d1).SCALE_SELECT) return;
            if (isBundledUpdatesEnabled && displayConfirmationButtons && newValue && confidence) {
                setPendingValue({
                    value: newValue,
                    confidence: confidence,
                    interval: newSelectedInterval
                });
                return;
            }
            if (shouldCommitSelection) {
                setCurentValue(newValue);
                setSelectedInterval(newValue !== undefined ? newSelectedInterval : undefined);
            }
            onChange(newValue, confidence, newSelectedInterval);
            setIsOpen(false);
            onClose?.();
        };
        $[15] = displayConfirmationButtons;
        $[16] = onChange;
        $[17] = onClose;
        $[18] = shouldCommitSelection;
        $[19] = t13;
    } else t13 = $[19];
    const onDateChange = t13;
    let t14;
    if ($[20] !== onChange || $[21] !== onClose || $[22] !== pendingValue) {
        t14 = ()=>{
            if (!pendingValue) return;
            setCurentValue(pendingValue.value);
            setSelectedInterval(pendingValue.interval);
            onChange(pendingValue.value, pendingValue.confidence, pendingValue.interval);
            setIsOpen(false);
            setPendingValue(undefined);
            onClose?.();
        };
        $[20] = onChange;
        $[21] = onClose;
        $[22] = pendingValue;
        $[23] = t14;
    } else t14 = $[23];
    const onConfirm = t14;
    let t15;
    if ($[24] !== onDateChange) {
        t15 = ()=>{
            onDateChange();
        };
        $[24] = onDateChange;
        $[25] = t15;
    } else t15 = $[25];
    const onClearDate = t15;
    let t16;
    if ($[26] !== closePopup || $[27] !== confirmationMessage || $[28] !== description || $[29] !== displayConfirmationButtons || $[30] !== formatMessage || $[31] !== granularities || $[32] !== intervals || $[33] !== isRangeSelect || $[34] !== maxDate || $[35] !== minDate || $[36] !== onConfirm || $[37] !== onDateChange || $[38] !== pendingValue || $[39] !== subtitle || $[40] !== value || $[41] !== withTimeScale) {
        t16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, (subtitle || description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.popupHeader
            }, subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "xsmall",
                as: "h2"
            }, subtitle)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a444c97e41712140$export$2e2bcd8739ae039), {
                key: `${intervals?.length ?? 0}-${intervals?.[0]?.startDate.getTime() ?? ""}`,
                value: value,
                onChange: onDateChange,
                withTimeScale: withTimeScale,
                minDate: minDate,
                maxDate: maxDate,
                granularities: granularities,
                intervals: intervals,
                isRangeSelect: isRangeSelect
            }), isBundledUpdatesEnabled && displayConfirmationButtons && pendingValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, confirmationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.confirmationMessage
            }, confirmationMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.confirmButtons
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: onConfirm
            }, formatMessage($a8b8832c37e6865f$var$confirmButtonMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: closePopup
            }, formatMessage($a8b8832c37e6865f$var$cancelButtonMessage))))));
        $[26] = closePopup;
        $[27] = confirmationMessage;
        $[28] = description;
        $[29] = displayConfirmationButtons;
        $[30] = formatMessage;
        $[31] = granularities;
        $[32] = intervals;
        $[33] = isRangeSelect;
        $[34] = maxDate;
        $[35] = minDate;
        $[36] = onConfirm;
        $[37] = onDateChange;
        $[38] = pendingValue;
        $[39] = subtitle;
        $[40] = value;
        $[41] = withTimeScale;
        $[42] = t16;
    } else t16 = $[42];
    const t17 = isOpen && !disabled;
    let t18;
    if ($[43] !== appearance || $[44] !== currentValue || $[45] !== disabled || $[46] !== onClearDate || $[47] !== placeholder || $[48] !== selectIconPlacement || $[49] !== selectedInterval?.name || $[50] !== showPlaceholderWithSubtleText || $[51] !== size || $[52] !== togglePopup || $[53] !== withTimeScale) {
        t18 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nrck.DateRange), {
                onClick: disabled ? undefined : togglePopup,
                value: currentValue,
                placeholder: placeholder,
                triggerProps: triggerProps,
                onClearDate: onClearDate,
                withTimeScale: withTimeScale,
                appearance: appearance,
                disabled: disabled,
                showPlaceholderWithSubtleText: showPlaceholderWithSubtleText,
                intervalDisplayName: selectedInterval?.name,
                selectIconPlacement: selectIconPlacement,
                size: size
            });
        $[43] = appearance;
        $[44] = currentValue;
        $[45] = disabled;
        $[46] = onClearDate;
        $[47] = placeholder;
        $[48] = selectIconPlacement;
        $[49] = selectedInterval?.name;
        $[50] = showPlaceholderWithSubtleText;
        $[51] = size;
        $[52] = togglePopup;
        $[53] = withTimeScale;
        $[54] = t18;
    } else t18 = $[54];
    let t19;
    if ($[55] !== closePopup || $[56] !== t16 || $[57] !== t17 || $[58] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            zIndex: 610,
            placement: "bottom-start",
            content: t16,
            isOpen: t17,
            onClose: closePopup,
            shouldUseCaptureOnOutsideClick: true,
            trigger: t18
        });
        $[55] = closePopup;
        $[56] = t16;
        $[57] = t17;
        $[58] = t18;
        $[59] = t19;
    } else t19 = $[59];
    return t19;
} : (props)=>{
    const { value: value, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, onClose: onClose, withTimeScale: withTimeScale = true, appearance: appearance = 'default', disabled: disabled = false, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, intervalValue: intervalValue, selectIconPlacement: selectIconPlacement = 'end', size: size, isRangeSelect: isRangeSelect, confirmationMessage: confirmationMessage, displayConfirmationButtons: displayConfirmationButtons = false, shouldCommitSelection: shouldCommitSelection = true, subtitle: subtitle, description: description } = props;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isControlled = 'value' in props;
    const isBundledUpdatesEnabled = (0, $iDrrr.fg)('goal_types_m3_bundled_updates');
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [currentValue, setCurentValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(value ?? defaultValue);
    const [selectedInterval, setSelectedInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(intervalValue);
    const [pendingValue, setPendingValue] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const locale = (0, $k0hOH.useDateLocale)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (isControlled) setCurentValue(value);
    }, [
        value,
        isControlled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if ((0, $iDrrr.fg)('mercury_web_enable_intervals')) {
            if (intervalValue) setCurentValue((0, $1soKT.intervalToDatePickerValue)(intervalValue, intervalValue.startDate.getFullYear(), locale));
            setSelectedInterval(intervalValue);
        }
    }, [
        intervalValue,
        locale
    ]);
    const togglePopup = (0, $cozmU.useCallback)(()=>{
        if (!disabled) {
            if (isOpen) onClose?.();
            setIsOpen(!isOpen);
        }
    }, [
        isOpen,
        onClose,
        disabled
    ]);
    const closePopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setPendingValue(undefined);
        onClose?.();
    }, [
        onClose
    ]);
    const onDateChange = (0, $cozmU.useCallback)((newValue, confidence, newSelectedInterval, source)=>{
        if (source === (0, $8d907002e8695178$export$d19e7d63e5f456d1).SCALE_SELECT) return;
        if (isBundledUpdatesEnabled && displayConfirmationButtons && newValue && confidence) {
            setPendingValue({
                value: newValue,
                confidence: confidence,
                interval: newSelectedInterval
            });
            return;
        }
        if (shouldCommitSelection) {
            setCurentValue(newValue);
            setSelectedInterval(newValue !== undefined ? newSelectedInterval : undefined);
        }
        onChange(newValue, confidence, newSelectedInterval);
        setIsOpen(false);
        onClose?.();
    }, [
        onChange,
        onClose,
        displayConfirmationButtons,
        isBundledUpdatesEnabled,
        shouldCommitSelection
    ]);
    const onConfirm = (0, $cozmU.useCallback)(()=>{
        if (!pendingValue) return;
        setCurentValue(pendingValue.value);
        setSelectedInterval(pendingValue.interval);
        onChange(pendingValue.value, pendingValue.confidence, pendingValue.interval);
        setIsOpen(false);
        setPendingValue(undefined);
        onClose?.();
    }, [
        pendingValue,
        onChange,
        onClose
    ]);
    const onClearDate = (0, $cozmU.useCallback)(()=>{
        onDateChange();
    }, [
        onDateChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        zIndex: 610,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, (subtitle || description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.popupHeader
            }, subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                size: "xsmall",
                as: "h2"
            }, subtitle)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a444c97e41712140$export$2e2bcd8739ae039), {
                key: `${intervals?.length ?? 0}-${intervals?.[0]?.startDate.getTime() ?? ''}`,
                value: value,
                onChange: onDateChange,
                withTimeScale: withTimeScale,
                minDate: minDate,
                maxDate: maxDate,
                granularities: granularities,
                intervals: intervals,
                isRangeSelect: isRangeSelect
            }), isBundledUpdatesEnabled && displayConfirmationButtons && pendingValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, confirmationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.confirmationMessage
            }, confirmationMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a8b8832c37e6865f$var$styles.confirmButtons
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: onConfirm
            }, formatMessage($a8b8832c37e6865f$var$confirmButtonMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: closePopup
            }, formatMessage($a8b8832c37e6865f$var$cancelButtonMessage)))))),
        isOpen: isOpen && !disabled,
        onClose: closePopup,
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7nrck.DateRange), {
                onClick: disabled ? undefined : togglePopup,
                value: currentValue,
                placeholder: placeholder,
                triggerProps: triggerProps,
                onClearDate: onClearDate,
                withTimeScale: withTimeScale,
                appearance: appearance,
                disabled: disabled,
                showPlaceholderWithSubtleText: showPlaceholderWithSubtleText,
                intervalDisplayName: selectedInterval?.name,
                selectIconPlacement: selectIconPlacement,
                size: size
            })
    });
});
module.exports["DateRangePicker"] = $a8b8832c37e6865f$export$17334619f3ac2224;

});

parcelRegister("1soKT", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");


var $esV19 = parcelRequire("esV19");


var $k5sGX = parcelRequire("k5sGX");


var $1xxT0 = parcelRequire("1xxT0");


var $26dZt = parcelRequire("26dZt");


var $k0hOH = parcelRequire("k0hOH");

const $501e5c49a41974c7$export$27765aab0dadeddc = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    INTERVAL: 'INTERVAL'
};
const $501e5c49a41974c7$var$MONTH_THRESHOLD = 31;
const $501e5c49a41974c7$var$DAY_THRESHOLD = 1;
const $501e5c49a41974c7$export$73adc9cbc5981a56 = (dateObj)=>{
    if (dateObj) {
        const dateDiff = (0, $jb2R2.default)(new Date(dateObj.end), new Date(dateObj.start));
        if (dateDiff < $501e5c49a41974c7$var$DAY_THRESHOLD) return $501e5c49a41974c7$export$27765aab0dadeddc.DAY;
        if (dateDiff <= $501e5c49a41974c7$var$MONTH_THRESHOLD) return $501e5c49a41974c7$export$27765aab0dadeddc.MONTH;
        return $501e5c49a41974c7$export$27765aab0dadeddc.QUARTER;
    }
    // If date is somehow undefined, we'll show quarters picker by default
    return $501e5c49a41974c7$export$27765aab0dadeddc.QUARTER;
};
const $501e5c49a41974c7$var$DEFAULT_FISCAL_YEAR_PREFIX = 'FY';
const $501e5c49a41974c7$export$3a6708e815f1ccd1 = (locale, dateString, placeholder, withTimeScale, intervalDisplayName, fiscalYearPrefix)=>{
    if (!dateString) return placeholder;
    const endDate = (0, $k5sGX.default)(dateString.end);
    if (!(0, $esV19.default)(endDate)) return placeholder;
    if (intervalDisplayName !== undefined) {
        const startDate = (0, $k5sGX.default)(dateString.start);
        if (!(0, $esV19.default)(startDate)) return placeholder;
        return (0, $26dZt.formatNiceIntervalRangeDate)(fiscalYearPrefix ?? $501e5c49a41974c7$var$DEFAULT_FISCAL_YEAR_PREFIX, intervalDisplayName, startDate, endDate, locale);
    }
    switch($501e5c49a41974c7$export$73adc9cbc5981a56(dateString)){
        case $501e5c49a41974c7$export$27765aab0dadeddc.DAY:
            return (0, $26dZt.formatNiceDate)(endDate, locale);
        case $501e5c49a41974c7$export$27765aab0dadeddc.QUARTER:
            return (0, $26dZt.formatNiceQuarterDate)(endDate, locale);
        default:
        case $501e5c49a41974c7$export$27765aab0dadeddc.MONTH:
            return withTimeScale ? (0, $26dZt.formatNiceMonthDate)(endDate, locale) : (0, $26dZt.formatMonthOnlyDate)(endDate, locale);
    }
};
function $501e5c49a41974c7$export$b034b69aae1dad2a(interval, displayYear, locale) {
    const startInDisplayYear = new Date(displayYear, interval.startDate.getMonth(), interval.startDate.getDate());
    const endInDisplayYear = new Date(displayYear, interval.endDate.getMonth(), interval.endDate.getDate());
    return {
        start: (0, $26dZt.formatIsoLocalDate)(startInDisplayYear, locale),
        end: (0, $26dZt.formatIsoLocalDate)(endInDisplayYear, locale)
    };
}
const $501e5c49a41974c7$export$dcf81686e850fc1a = (props)=>{
    const parsedDate = props.date ? (0, $k5sGX.default)(props.date) : new Date();
    return {
        initialYear: parsedDate.getFullYear(),
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth()
    };
};
const $501e5c49a41974c7$export$470b6320f3327b8a = (date)=>{
    if (!date) return undefined;
    const parsedDate = (0, $k5sGX.default)(date);
    if (!(0, $esV19.default)(parsedDate)) return undefined;
    return {
        initialYear: parsedDate.getFullYear(),
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth()
    };
};
function $501e5c49a41974c7$export$b5a0a52d8148dacc(confidence) {
    if (!confidence) return false;
    return [
        'MONTH',
        'QUARTER',
        'DAY'
    ].includes(confidence);
}
const $501e5c49a41974c7$export$cb14a9963bfc66da = {
    [$501e5c49a41974c7$export$27765aab0dadeddc.DAY]: 100,
    [$501e5c49a41974c7$export$27765aab0dadeddc.MONTH]: 0,
    [$501e5c49a41974c7$export$27765aab0dadeddc.QUARTER]: -50
};
const $501e5c49a41974c7$export$32c50ab22112d6ce = (confidence)=>{
    // I hate JS. The number 0 is a false-y value. So we have to be explicit here for null checking
    if (confidence !== undefined && confidence !== null) {
        if (confidence >= $501e5c49a41974c7$export$cb14a9963bfc66da[$501e5c49a41974c7$export$27765aab0dadeddc.DAY]) return $501e5c49a41974c7$export$27765aab0dadeddc.DAY;
        if (confidence >= $501e5c49a41974c7$export$cb14a9963bfc66da[$501e5c49a41974c7$export$27765aab0dadeddc.MONTH]) return $501e5c49a41974c7$export$27765aab0dadeddc.MONTH;
        return $501e5c49a41974c7$export$27765aab0dadeddc.QUARTER;
    } else // If confidence is somehow undefined, we'll show full date just in case
    return $501e5c49a41974c7$export$27765aab0dadeddc.DAY;
};
const $501e5c49a41974c7$export$bbe804fa4e5af3bf = (targetDate)=>{
    if (!targetDate?.date) return undefined;
    if (targetDate.confidence === 'DAY') return {
        start: targetDate.date,
        end: targetDate.date
    };
    if (targetDate.confidence === 'MONTH') return {
        // Threshold for daily view is one day difference
        start: (0, $1xxT0.default)(new Date(targetDate.date), 1).toString(),
        end: targetDate.date
    };
    return {
        // We show the quarter view by default
        start: '',
        end: targetDate.date
    };
};
module.exports["DateRangeScale"] = $501e5c49a41974c7$export$27765aab0dadeddc;
module.exports["getDateRangeScale"] = $501e5c49a41974c7$export$73adc9cbc5981a56;
module.exports["renderDateString"] = $501e5c49a41974c7$export$3a6708e815f1ccd1;
module.exports["intervalToDatePickerValue"] = $501e5c49a41974c7$export$b034b69aae1dad2a;
module.exports["getInitialMonthPickerDate"] = $501e5c49a41974c7$export$dcf81686e850fc1a;
module.exports["getMonthPickerDate"] = $501e5c49a41974c7$export$470b6320f3327b8a;
module.exports["isValidConfidence"] = $501e5c49a41974c7$export$b5a0a52d8148dacc;
module.exports["getFuzzyScale"] = $501e5c49a41974c7$export$32c50ab22112d6ce;
module.exports["convertTargetDateToRange"] = $501e5c49a41974c7$export$bbe804fa4e5af3bf;

});

parcelRegister("7nrck", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ad7Ou = parcelRequire("ad7Ou");


var $824lD = parcelRequire("824lD");


var $7sJoX = parcelRequire("7sJoX");


var $aCJyI = parcelRequire("aCJyI");


var $iDrrr = parcelRequire("iDrrr");


var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $4aRua = parcelRequire("4aRua");


var $kmtcp = parcelRequire("kmtcp");

const $abf8b9041b94101a$var$wrapperStyles = null;
const $abf8b9041b94101a$var$normalHeight = null;
const $abf8b9041b94101a$var$reducedHeight = null;
const $abf8b9041b94101a$var$dangerStyles = null;
const $abf8b9041b94101a$var$upliftStyles = null;
const $abf8b9041b94101a$var$upliftCompactPaddingStyles = null;
const $abf8b9041b94101a$var$upliftSpaciousPaddingStyles = null; /**
                                           * Match spacious lozenge height (2rem / 32px including border) used in AGG goal header.
                                           */ 
const $abf8b9041b94101a$var$upliftMediumHeightStyles = null;
const $abf8b9041b94101a$var$upliftDangerStyles = null; /**
                                  * These styles replicate the styling of the DatePicker component which doesn't support fuzzy date selection.
                                  */ 
const $abf8b9041b94101a$var$selectBaseStyles = null;
const $abf8b9041b94101a$var$selectDisabledStyles = null;
const $abf8b9041b94101a$var$focusRingVariantStyles = null;
const $abf8b9041b94101a$var$normalBorderVariantStyles = null;
const $abf8b9041b94101a$var$nonClickableWrapperStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    blockSize: 'min-content',
    width: 'max-content',
    height: '32px',
    paddingInlineStart: 'space.075',
    paddingInlineEnd: 'space.150',
    backgroundColor: 'color.background.neutral',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $abf8b9041b94101a$export$829bd850c745b6e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(60);
    const { onClick: onClick, triggerProps: t0, placeholder: placeholder, value: value, withTimeScale: withTimeScale, appearance: appearance, showIcon: t1, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, size: size, intervalDisplayName: intervalDisplayName, dateLabel: dateLabelOverride, selectIconPlacement: t2, forceShowFocusRing: t3, disabled: t4 } = props;
    let t5;
    if ($[0] !== t0) {
        t5 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t5;
    } else t5 = $[1];
    const triggerProps = t5;
    const showIcon = t1 === undefined ? true : t1;
    const selectIconPlacement = t2 === undefined ? "end" : t2;
    const forceShowFocusRing = t3 === undefined ? false : t3;
    const disabled = t4 === undefined ? false : t4;
    let t6;
    if ($[2] !== intervalDisplayName || $[3] !== placeholder || $[4] !== value || $[5] !== withTimeScale) {
        t6 = {
            value: value,
            placeholder: placeholder,
            withTimeScale: withTimeScale,
            intervalDisplayName: intervalDisplayName
        };
        $[2] = intervalDisplayName;
        $[3] = placeholder;
        $[4] = value;
        $[5] = withTimeScale;
        $[6] = t6;
    } else t6 = $[6];
    const computedDateLabel = (0, $kmtcp.useDateLabel)(t6);
    const dateLabel = dateLabelOverride ?? computedDateLabel;
    const textColor = showPlaceholderWithSubtleText && !value ? "color.text.subtlest" : "color.text.subtle";
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $iDrrr.fg)("goal_types_m3_bundled_updates");
        $[7] = t7;
    } else t7 = $[7];
    const isBundledUpdatesEnabled = t7;
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $iDrrr.fg)("platform-dst-lozenge-tag-badge-visual-uplifts");
        $[8] = t8;
    } else t8 = $[8];
    const isUplift = t8;
    const isDanger = (isBundledUpdatesEnabled || isUplift) && appearance === "danger";
    const isSelect = appearance === "select";
    const calendarIconLabel = isBundledUpdatesEnabled ? "" : "calendar icon";
    let t9;
    bb0: {
        if (!isSelect) {
            let t10;
            if ($[9] !== isDanger) {
                t10 = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                        label: calendarIconLabel,
                        color: isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                    });
                $[9] = isDanger;
                $[10] = t10;
            } else t10 = $[10];
            let t11;
            if ($[11] !== isDanger || $[12] !== showIcon) {
                t11 = showIcon ? ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "",
                        size: "small",
                        color: isDanger ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #292A2E)"
                    }) : undefined;
                $[11] = isDanger;
                $[12] = showIcon;
                $[13] = t11;
            } else t11 = $[13];
            let t12;
            if ($[14] !== t10 || $[15] !== t11) {
                t12 = {
                    iconBefore: t10,
                    iconAfter: t11
                };
                $[14] = t10;
                $[15] = t11;
                $[16] = t12;
            } else t12 = $[16];
            t9 = t12;
            break bb0;
        }
        if (selectIconPlacement === "start") {
            let t10;
            if ($[17] !== disabled || $[18] !== isDanger) {
                t10 = {
                    iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                            label: "",
                            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                        })
                };
                $[17] = disabled;
                $[18] = isDanger;
                $[19] = t10;
            } else t10 = $[19];
            t9 = t10;
            break bb0;
        }
        if (!showIcon || selectIconPlacement !== "end") {
            let t10;
            if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
                t10 = {
                    iconBefore: undefined
                };
                $[20] = t10;
            } else t10 = $[20];
            t9 = t10;
            break bb0;
        }
        let t10;
        if ($[21] !== disabled) {
            t10 = {
                iconBefore: undefined,
                iconAfter: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                        label: "",
                        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : undefined
                    })
            };
            $[21] = disabled;
            $[22] = t10;
        } else t10 = $[22];
        t9 = t10;
    }
    const { iconBefore: iconBefore, iconAfter: iconAfter } = t9;
    const isSpacious = size === "medium";
    const lozengeSpacing = isSpacious ? "spacious" : "default";
    if (!onClick && !(isSelect && disabled)) {
        let t10;
        if ($[23] !== dateLabel || $[24] !== isDanger || $[25] !== isSpacious || $[26] !== lozengeSpacing || $[27] !== textColor) {
            t10 = isUplift ? /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
                appearance: isDanger ? "danger" : "neutral",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
                spacing: lozengeSpacing,
                style: {
                    backgroundColor: "transparent"
                }
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                as: "span",
                size: isSpacious ? "medium" : "small",
                weight: isSpacious ? "medium" : undefined,
                color: isDanger ? "color.text.danger" : textColor
            }, dateLabel)) : /*#__PURE__*/ $cozmU.createElement((0, $kz1Yj.Inline), {
                alignBlock: "center",
                space: "space.025",
                xcss: $abf8b9041b94101a$var$nonClickableWrapperStyles,
                testId: "date-range-trigger-wrapper"
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                color: "currentColor",
                spacing: "spacious",
                label: calendarIconLabel
            }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "medium",
                color: textColor
            }, dateLabel));
            $[23] = dateLabel;
            $[24] = isDanger;
            $[25] = isSpacious;
            $[26] = lozengeSpacing;
            $[27] = textColor;
            $[28] = t10;
        } else t10 = $[28];
        return t10;
    }
    const showReducedHeight = size !== "medium";
    let buttonContent;
    if (isSelect) {
        const t10 = disabled ? "color.text.disabled" : textColor;
        let t11;
        if ($[29] !== dateLabel || $[30] !== t10) {
            t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "regular",
                color: t10
            }, dateLabel);
            $[29] = dateLabel;
            $[30] = t10;
            $[31] = t11;
        } else t11 = $[31];
        buttonContent = t11;
    } else {
        if (isUplift) {
            const t10 = isDanger ? "color.text.danger" : textColor;
            let t11;
            if ($[32] !== dateLabel || $[33] !== t10) {
                t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    weight: "medium",
                    color: t10
                }, dateLabel);
                $[32] = dateLabel;
                $[33] = t10;
                $[34] = t11;
            } else t11 = $[34];
            buttonContent = t11;
        } else if (showPlaceholderWithSubtleText) {
            const t10 = isDanger ? "color.text.danger" : textColor;
            let t11;
            if ($[35] !== dateLabel || $[36] !== t10) {
                t11 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    color: t10
                }, dateLabel);
                $[35] = dateLabel;
                $[36] = t10;
                $[37] = t11;
            } else t11 = $[37];
            buttonContent = t11;
        } else buttonContent = dateLabel;
    }
    const t10 = showReducedHeight || isUplift && !isSelect && isSpacious ? "_3UvKzXPgdg _0XHyiFIZbP _3pWlA9ecOK _2uw4NfDIqT" : "_3UvKzXPgdg _2JTqCAUofl _0XHyiFIZbP _3pWlA9ecOK";
    const t11 = isSelect && "_4bCqV1NvrM _4hPtik6wH8 _0XHyiFS40j _2uw4NfDIqT _0VP3ny7Cj1 _4c0x0qYbGa _4vfxvo98eZ _0HefWmYbGa _01MY9FT6kp _4a3a0vnXvL _0zSnwiUlLl _2Xv6qGqWX3 _33dW8o7Cj1";
    const t12 = isSelect && forceShowFocusRing ? "_2fiCpx98eZ _3xjvdYYbGa _4srDCPT6kp _3kPYPJnXvL _09kGcnUlLl" : "_3kPYPJHKt7";
    const t13 = isSelect && disabled && "_3kPYPJhQC5 _04TovchQC5 _2yNUCAhQC5 _0VP3nyVrZW _33dW8oVrZW _2Xv6qGVrZW _3bLKxl18ZR _20Mjrv18ZR _01QWR318ZR";
    const t14 = !isUplift && isDanger && "_3kPYPJnod9 _4bCqV1NvrM _4hPtik6wH8 _21Jt35AyGJ _2Xv6qG1IMt";
    const t15 = isUplift && !isSelect && "_0bjKvDKTcp _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc";
    const t16 = isUplift && !isSelect && isSpacious && "_4b9RmQ8HPE";
    const t17 = isUplift && !isSelect && !isSpacious && "_4b9RmQ1Y8M";
    const t18 = isUplift && !isSelect && isSpacious && "_0jFU0VZ49V _3UvKzXPgdg _0XHyiFN91d _2JTqCAzUZr _2uw4NfDIqT";
    const t19 = isUplift && !isSelect && isDanger && "_3vBAKHnod9 _21Jt35AyGJ _2Xv6qGhH7k _0sptNMAyGJ";
    let t20;
    if ($[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t15 || $[44] !== t16 || $[45] !== t17 || $[46] !== t18 || $[47] !== t19) {
        t20 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _2fwxA5ecOK",
            t10,
            t11,
            t12,
            t13,
            t14,
            t15,
            t16,
            t17,
            t18,
            t19
        ]);
        $[38] = t10;
        $[39] = t11;
        $[40] = t12;
        $[41] = t13;
        $[42] = t14;
        $[43] = t15;
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
        $[47] = t19;
        $[48] = t20;
    } else t20 = $[48];
    let t21;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = isUplift && {
            spacing: "compact",
            appearance: "subtle"
        };
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== buttonContent || $[51] !== disabled || $[52] !== iconAfter || $[53] !== iconBefore || $[54] !== onClick || $[55] !== triggerProps) {
        t22 = /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            ...triggerProps,
            shouldFitContainer: true,
            isDisabled: disabled,
            onClick: onClick,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            testId: "date-range-trigger",
            ...t21
        }, buttonContent);
        $[50] = buttonContent;
        $[51] = disabled;
        $[52] = iconAfter;
        $[53] = iconBefore;
        $[54] = onClick;
        $[55] = triggerProps;
        $[56] = t22;
    } else t22 = $[56];
    let t23;
    if ($[57] !== t20 || $[58] !== t22) {
        t23 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "date-range-trigger-wrapper",
            className: t20
        }, t22);
        $[57] = t20;
        $[58] = t22;
        $[59] = t23;
    } else t23 = $[59];
    return t23;
} : (props)=>{
    const { onClick: onClick, triggerProps: triggerProps = {}, placeholder: placeholder, value: value, withTimeScale: withTimeScale, appearance: appearance, showIcon: showIcon = true, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, size: size, intervalDisplayName: intervalDisplayName, dateLabel: dateLabelOverride, selectIconPlacement: selectIconPlacement = 'end', forceShowFocusRing: forceShowFocusRing = false, disabled: disabled = false } = props;
    const computedDateLabel = (0, $kmtcp.useDateLabel)({
        value: value,
        placeholder: placeholder,
        withTimeScale: withTimeScale,
        intervalDisplayName: intervalDisplayName
    });
    const dateLabel = dateLabelOverride ?? computedDateLabel;
    const textColor = showPlaceholderWithSubtleText && !value ? 'color.text.subtlest' : 'color.text.subtle';
    const isBundledUpdatesEnabled = (0, $iDrrr.fg)('goal_types_m3_bundled_updates');
    const isUplift = (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const isDanger = (isBundledUpdatesEnabled || isUplift) && appearance === 'danger';
    const isSelect = appearance === 'select'; // Decorative when date text is adjacent; avoid hardcoded English "calendar icon".
    const calendarIconLabel = isBundledUpdatesEnabled ? '' : 'calendar icon';
    const { iconBefore: iconBefore, iconAfter: iconAfter } = (0, $cozmU.useMemo)(()=>{
        if (!isSelect) return {
            iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                    label: calendarIconLabel,
                    color: isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                }),
            iconAfter: showIcon ? ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    size: "small",
                    color: isDanger ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #292A2E)"
                }) : undefined
        };
        if (selectIconPlacement === 'start') return {
            iconBefore: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                    label: "",
                    color: disabled ? "var(--ds-icon-disabled, #080F214A)" : isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                })
        };
        if (!showIcon || selectIconPlacement !== 'end') return {
            iconBefore: undefined
        };
        return {
            iconBefore: undefined,
            iconAfter: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
                    label: "",
                    color: disabled ? "var(--ds-icon-disabled, #080F214A)" : undefined
                })
        };
    }, [
        isSelect,
        selectIconPlacement,
        showIcon,
        isDanger,
        disabled,
        calendarIconLabel
    ]);
    const isSpacious = size === 'medium';
    const lozengeSpacing = isSpacious ? 'spacious' : 'default';
    if (!onClick && !(isSelect && disabled)) return isUplift ? /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
        appearance: isDanger ? 'danger' : 'neutral',
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($824lD))),
        spacing: lozengeSpacing,
        // background keeps the lozenge inline with surrounding content.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: 'transparent'
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "span",
        size: isSpacious ? 'medium' : 'small',
        weight: isSpacious ? 'medium' : undefined,
        color: isDanger ? 'color.text.danger' : textColor
    }, dateLabel)) : /*#__PURE__*/ $cozmU.createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025",
        xcss: $abf8b9041b94101a$var$nonClickableWrapperStyles,
        testId: "date-range-trigger-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($824lD))), {
        color: "currentColor",
        spacing: "spacious",
        label: calendarIconLabel
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium",
        color: textColor
    }, dateLabel));
    const showReducedHeight = size !== 'medium';
    let buttonContent;
    if (isSelect) buttonContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: 'regular',
        color: disabled ? 'color.text.disabled' : textColor
    }, dateLabel);
    else if (isUplift) buttonContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium",
        color: isDanger ? 'color.text.danger' : textColor
    }, dateLabel);
    else if (showPlaceholderWithSubtleText) buttonContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: isDanger ? 'color.text.danger' : textColor
    }, dateLabel);
    else buttonContent = dateLabel;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "date-range-trigger-wrapper",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _2fwxA5ecOK",
            showReducedHeight || isUplift && !isSelect && isSpacious ? "_3UvKzXPgdg _0XHyiFIZbP _3pWlA9ecOK _2uw4NfDIqT" : "_3UvKzXPgdg _2JTqCAUofl _0XHyiFIZbP _3pWlA9ecOK",
            isSelect && "_4bCqV1NvrM _4hPtik6wH8 _0XHyiFS40j _2uw4NfDIqT _0VP3ny7Cj1 _4c0x0qYbGa _4vfxvo98eZ _0HefWmYbGa _01MY9FT6kp _4a3a0vnXvL _0zSnwiUlLl _2Xv6qGqWX3 _33dW8o7Cj1",
            isSelect && forceShowFocusRing ? "_2fiCpx98eZ _3xjvdYYbGa _4srDCPT6kp _3kPYPJnXvL _09kGcnUlLl" : "_3kPYPJHKt7",
            isSelect && disabled && "_3kPYPJhQC5 _04TovchQC5 _2yNUCAhQC5 _0VP3nyVrZW _33dW8oVrZW _2Xv6qGVrZW _3bLKxl18ZR _20Mjrv18ZR _01QWR318ZR",
            !isUplift && isDanger && "_3kPYPJnod9 _4bCqV1NvrM _4hPtik6wH8 _21Jt35AyGJ _2Xv6qG1IMt",
            isUplift && !isSelect && "_0bjKvDKTcp _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc",
            isUplift && !isSelect && isSpacious && "_4b9RmQ8HPE",
            isUplift && !isSelect && !isSpacious && "_4b9RmQ1Y8M",
            isUplift && !isSelect && isSpacious && "_0jFU0VZ49V _3UvKzXPgdg _0XHyiFN91d _2JTqCAzUZr _2uw4NfDIqT",
            isUplift && !isSelect && isDanger && "_3vBAKHnod9 _21Jt35AyGJ _2Xv6qGhH7k _0sptNMAyGJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        ...triggerProps,
        shouldFitContainer: true,
        isDisabled: disabled,
        onClick: onClick,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        testId: "date-range-trigger",
        ...isUplift && {
            spacing: 'compact',
            appearance: 'subtle'
        }
    }, buttonContent));
};
module.exports["DateRange"] = $abf8b9041b94101a$export$829bd850c745b6e;

});

parcelRegister("kmtcp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $1soKT = parcelRequire("1soKT");

var $k0hOH = parcelRequire("k0hOH");

const $f8c5ce5296287c18$var$noDateSetMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range.no-date-set",
    defaultMessage: "No target date set"
});
const $f8c5ce5296287c18$var$fiscalYearPrefixMessage = (0, $kSwu1.defineMessage)({
    id: "date-range-picker.date-range.fiscal-year-prefix",
    defaultMessage: "FY"
});
const $f8c5ce5296287c18$export$817f035fae319df = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { value: date, placeholder: placeholder, withTimeScale: withTimeScale, intervalDisplayName: intervalDisplayName } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const locale = (0, $k0hOH.useDateLocale)();
    let t1;
    if ($[0] !== intl || $[1] !== placeholder) {
        t1 = placeholder ? placeholder : intl.formatMessage($f8c5ce5296287c18$var$noDateSetMessage);
        $[0] = intl;
        $[1] = placeholder;
        $[2] = t1;
    } else t1 = $[2];
    const noDateSelectedMessage = t1;
    let t2;
    if ($[3] !== date || $[4] !== intervalDisplayName || $[5] !== intl || $[6] !== locale || $[7] !== noDateSelectedMessage || $[8] !== placeholder || $[9] !== withTimeScale) {
        const fiscalYearPrefix = intervalDisplayName !== undefined ? intl.formatMessage($f8c5ce5296287c18$var$fiscalYearPrefixMessage) : undefined;
        t2 = date ? (0, $1soKT.renderDateString)(locale, date, placeholder, withTimeScale, intervalDisplayName, fiscalYearPrefix) ?? noDateSelectedMessage : noDateSelectedMessage;
        $[3] = date;
        $[4] = intervalDisplayName;
        $[5] = intl;
        $[6] = locale;
        $[7] = noDateSelectedMessage;
        $[8] = placeholder;
        $[9] = withTimeScale;
        $[10] = t2;
    } else t2 = $[10];
    const dateLabel = t2;
    return dateLabel;
} : ({ value: date, placeholder: placeholder, withTimeScale: withTimeScale, intervalDisplayName: intervalDisplayName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const locale = (0, $k0hOH.useDateLocale)();
    const noDateSelectedMessage = placeholder ? placeholder : intl.formatMessage($f8c5ce5296287c18$var$noDateSetMessage);
    const fiscalYearPrefix = intervalDisplayName !== undefined ? intl.formatMessage($f8c5ce5296287c18$var$fiscalYearPrefixMessage) : undefined;
    const dateLabel = date ? (0, $1soKT.renderDateString)(locale, date, placeholder, withTimeScale, intervalDisplayName, fiscalYearPrefix) ?? noDateSelectedMessage : noDateSelectedMessage;
    return dateLabel;
};
module.exports["useDateLabel"] = $f8c5ce5296287c18$export$817f035fae319df;

});

parcelRegister("bXFlG", function(module, exports) {

var $fmyEB = parcelRequire("fmyEB");


var $kvPeo = parcelRequire("kvPeo");


var $f6RxU = parcelRequire("f6RxU");


var $8Jp4I = parcelRequire("8Jp4I");


var $6Kop7 = parcelRequire("6Kop7");


var $hSoEi = parcelRequire("hSoEi");


var $2EI3u = parcelRequire("2EI3u");


var $8qMNj = parcelRequire("8qMNj");

const $c70aab678d1fe717$var$DEFAULT_DATE_FNS_OPTIONS = {
    weekStartsOn: 1
};
// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
const $c70aab678d1fe717$var$mixinDefaultOptions = (fn)=>{
    return function(...theArgs) {
        const lastIndex = fn.length - 1;
        if (fn.length === theArgs.length) theArgs[lastIndex] = {
            ...$c70aab678d1fe717$var$DEFAULT_DATE_FNS_OPTIONS,
            ...theArgs[lastIndex]
        };
        else theArgs[lastIndex] = $c70aab678d1fe717$var$DEFAULT_DATE_FNS_OPTIONS;
        return fn.apply(this, theArgs);
    };
};
const $c70aab678d1fe717$export$6ed034ce62348e4 = $c70aab678d1fe717$var$mixinDefaultOptions((0, $fmyEB.default));
const $c70aab678d1fe717$export$ef8b6d9133084f4e = $c70aab678d1fe717$var$mixinDefaultOptions((0, $kvPeo.default));
const $c70aab678d1fe717$export$d9468344d3651243 = $c70aab678d1fe717$var$mixinDefaultOptions((0, $f6RxU.default));
const $c70aab678d1fe717$export$efe19b760242b2fc = $c70aab678d1fe717$var$mixinDefaultOptions((0, $8Jp4I.default));
const $c70aab678d1fe717$export$6ea683876c36b8d2 = $c70aab678d1fe717$var$mixinDefaultOptions((0, $6Kop7.default));
const $c70aab678d1fe717$export$98e6a39c04603d36 = $c70aab678d1fe717$var$mixinDefaultOptions((0, $hSoEi.default));
const $c70aab678d1fe717$export$b04fdcda82decc6c = $c70aab678d1fe717$var$mixinDefaultOptions((0, $2EI3u.default));
const $c70aab678d1fe717$export$42c81a444fbfb5d4 = $c70aab678d1fe717$var$mixinDefaultOptions((0, $8qMNj.default));
module.exports["differenceInCalendarWeeks"] = $c70aab678d1fe717$export$6ed034ce62348e4;
module.exports["format"] = $c70aab678d1fe717$export$d9468344d3651243;
module.exports["isSameWeek"] = $c70aab678d1fe717$export$6ea683876c36b8d2;
module.exports["parse"] = $c70aab678d1fe717$export$98e6a39c04603d36;

});

parcelRegister("h07Gd", function(module, exports) {
const $9966238143dc5fc9$export$7eec4b04e46b2bbb = 'd';
const $9966238143dc5fc9$export$62bca61de2e93906 = 'd MMM';
const $9966238143dc5fc9$export$ab8da37e29943dac = 'd MMM yyyy';
const $9966238143dc5fc9$export$4eb9e1cb04482994 = 'd MMMM yyyy';
const $9966238143dc5fc9$export$995fc5e95216ff51 = 'MMMM';
const $9966238143dc5fc9$export$7aa8df5d3355fa4a = 'MMM';
const $9966238143dc5fc9$export$e8d0682eb7d102dc = 'MMM yyyy';
const $9966238143dc5fc9$export$f0cc54e1ef1d4992 = 'MMMM yyyy';
const $9966238143dc5fc9$export$776919ea04c83e30 = 'dd-MMM-yyyy';
const $9966238143dc5fc9$export$c6c89fea1560539e = 'd MMMM yyyy h:mm a';
const $9966238143dc5fc9$export$bbb765b7b56eaefb = 'yyyy-MM-dd';
const $9966238143dc5fc9$export$e1e67977af8d567 = 'HH:mm:ss';
const $9966238143dc5fc9$export$c8cdef0703935cfd = `${$9966238143dc5fc9$export$bbb765b7b56eaefb}'T'${$9966238143dc5fc9$export$e1e67977af8d567}`;
const $9966238143dc5fc9$export$9cdd86a0412967e3 = 'yyyy/MM/dd';
const $9966238143dc5fc9$export$8d4e01dc6271a4b = 'FY';
module.exports["SAME_MONTH_FORMAT"] = $9966238143dc5fc9$export$7eec4b04e46b2bbb;
module.exports["SAME_YEAR_FORMAT"] = $9966238143dc5fc9$export$62bca61de2e93906;
module.exports["DIFF_YEAR_FORMAT"] = $9966238143dc5fc9$export$ab8da37e29943dac;
module.exports["FULL_DATE_FORMAT"] = $9966238143dc5fc9$export$4eb9e1cb04482994;
module.exports["MONTH_ONLY_FORMAT"] = $9966238143dc5fc9$export$995fc5e95216ff51;
module.exports["MONTH_ONLY_FORMAT_SHORT"] = $9966238143dc5fc9$export$7aa8df5d3355fa4a;
module.exports["MONTH_ONLY_FORMAT_DIFF_YEAR"] = $9966238143dc5fc9$export$e8d0682eb7d102dc;
module.exports["MONTH_WITH_YEAR"] = $9966238143dc5fc9$export$f0cc54e1ef1d4992;
module.exports["FULL_NICE_FORMAT"] = $9966238143dc5fc9$export$776919ea04c83e30;
module.exports["NICE_DATE_TIME"] = $9966238143dc5fc9$export$c6c89fea1560539e;
module.exports["ISO_LOCAL_DATE"] = $9966238143dc5fc9$export$bbb765b7b56eaefb;
module.exports["ISO_LOCAL_DATE_TIME"] = $9966238143dc5fc9$export$c8cdef0703935cfd;
module.exports["ISO_LOCAL_DATE_WITH_SLASHES"] = $9966238143dc5fc9$export$9cdd86a0412967e3;

});

parcelRegister("2EI3u", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ef17da906f3b41f$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $dkBOe = parcelRequire("dkBOe");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $4m74k = parcelRequire("4m74k");

function $1ef17da906f3b41f$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(2, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = (0, $kr6hK.default)(dirtyDay);
    var currentDay = date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $gkHoc.default)(date, diff);
}

});


//# sourceMappingURL=ProfileCard.74146758.js.map
